var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as url from 'url';
export function isResponseEmpty(response) {
    var contentLength = response.headers.get('Content-Length');
    return contentLength != null && Number.parseInt(contentLength, 10) === 0;
}
export function isResponseJson(response) {
    var contentType = response.headers.get('Content-Type');
    return contentType != null && contentType.indexOf('json') >= 0;
}
export function parseJson(response) {
    return !isResponseEmpty(response) && isResponseJson(response) ? response.json() : Promise.resolve();
}
export function parseHeaders(response) {
    var headers = {};
    response.headers.forEach(function (value, key) {
        headers[key.toLowerCase()] = value;
    });
    return headers;
}
export function stripQuery(query) {
    if (query === void 0) { query = {}; }
    var initialValue = {};
    return Object.keys(query).reduce(function (previousValue, key) {
        var value = query[key];
        if (value != null)
            previousValue[key] = value;
        return previousValue;
    }, initialValue);
}
var $HttpClient = /** @class */ (function () {
    function $HttpClient(options) {
        this.options = options;
    }
    $HttpClient.prototype.request = function (options) {
        var finalUrl = url.format({
            hostname: 'api.flow.io',
            pathname: options.endpoint,
            protocol: 'https:',
            query: stripQuery(options.query),
        });
        var finalHeaders = __assign({ accept: 'application/json', 'content-type': 'application/json' }, options.headers);
        var request = {
            body: options.body,
            headers: finalHeaders,
            method: options.method,
            url: finalUrl,
        };
        return this.options.fetch(request.url, {
            body: JSON.stringify(request.body),
            headers: request.headers,
            method: request.method,
        }).then(function (response) {
            return parseJson(response).then(function (json) {
                return {
                    body: json,
                    headers: parseHeaders(response),
                    ok: response.ok,
                    request: request,
                    status: response.status,
                    statusText: response.statusText,
                };
            });
        });
    };
    return $HttpClient;
}());
export { $HttpClient };
var $Resource = /** @class */ (function () {
    function $Resource(options) {
        this.client = new $HttpClient(options);
    }
    return $Resource;
}());
export { $Resource };
var AddressConfigurationsResource = /** @class */ (function (_super) {
    __extends(AddressConfigurationsResource, _super);
    function AddressConfigurationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Search checkout address configurations.*/
    AddressConfigurationsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/address/configurations",
            headers: params.headers,
            method: 'GET',
            query: {
                context: params.context,
                country: params.country,
            },
        });
    };
    return AddressConfigurationsResource;
}($Resource));
export { AddressConfigurationsResource };
var AllocationsResource = /** @class */ (function (_super) {
    __extends(AllocationsResource, _super);
    function AllocationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Order-level price details allocated using a strategy among individual order item units.*/
    AllocationsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/orders/allocations/" + encodeURIComponent(params.number),
            headers: params.headers,
            method: 'GET',
        });
    };
    return AllocationsResource;
}($Resource));
export { AllocationsResource };
var AttributesResource = /** @class */ (function (_super) {
    __extends(AttributesResource, _super);
    function AttributesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Search attributes. Always paginated.*/
    AttributesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/attributes",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                intent: params.intent,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Add attribute*/
    AttributesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/attributes",
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Create or update a batch of attributes*/
    AttributesResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/attributes",
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Provides visibility into recent changes of each object, including deletion*/
    AttributesResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/attributes/versions",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Returns information about a specific attribute.*/
    AttributesResource.prototype.getByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/attributes/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Create or update an attribute with the specified key.*/
    AttributesResource.prototype.putByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/attributes/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Delete an attribute with the specified key.*/
    AttributesResource.prototype.deleteByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/attributes/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return AttributesResource;
}($Resource));
export { AttributesResource };
var CatalogsResource = /** @class */ (function (_super) {
    __extends(CatalogsResource, _super);
    function CatalogsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns information about a specific catalog.*/
    CatalogsResource.prototype.getCatalog = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/catalog",
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Search global restrictions. Always paginated.*/
    CatalogsResource.prototype.getCatalogAndRestrictions = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/catalog/restrictions",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                number: params.number,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Returns a specific globally restricted item.*/
    CatalogsResource.prototype.getCatalogAndRestrictionsByNumber = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/catalog/restrictions/" + encodeURIComponent(params.number),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Upsert a global restriction*/
    CatalogsResource.prototype.putCatalogAndRestrictionsByNumber = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/catalog/restrictions/" + encodeURIComponent(params.number),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Delete the global restriction for this catalog item number*/
    CatalogsResource.prototype.deleteCatalogAndRestrictionsByNumber = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/catalog/restrictions/" + encodeURIComponent(params.number),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    /*Get statistics for this organization's catalog.*/
    CatalogsResource.prototype.getCatalogAndStatistics = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/catalog/statistics",
            headers: params.headers,
            method: 'GET',
        });
    };
    return CatalogsResource;
}($Resource));
export { CatalogsResource };
var CheckoutAttributesResource = /** @class */ (function (_super) {
    __extends(CheckoutAttributesResource, _super);
    function CheckoutAttributesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckoutAttributesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/checkout/attributes",
            headers: params.headers,
            method: 'GET',
            query: {
                experience_key: params.experience_key,
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    CheckoutAttributesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/checkout/attributes",
            headers: params.headers,
            method: 'POST',
            query: {
                context: params.context,
            },
        });
    };
    CheckoutAttributesResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/checkout/attributes/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    CheckoutAttributesResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/checkout/attributes/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'PUT',
            query: {
                context: params.context,
            },
        });
    };
    CheckoutAttributesResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/checkout/attributes/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return CheckoutAttributesResource;
}($Resource));
export { CheckoutAttributesResource };
var CheckoutItemContentsResource = /** @class */ (function (_super) {
    __extends(CheckoutItemContentsResource, _super);
    function CheckoutItemContentsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns a localized view of 1 or more items in the context of checkout, returning data specifically related to rendering a view of an item in a cart or checkout page.*/
    CheckoutItemContentsResource.prototype.getCheckout = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.experience_key) + "/item/content/checkout",
            headers: params.headers,
            method: 'GET',
            query: {
                context: params.context,
                limit: params.limit,
                number: params.number,
                offset: params.offset,
            },
        });
    };
    return CheckoutItemContentsResource;
}($Resource));
export { CheckoutItemContentsResource };
var CreditPaymentsResource = /** @class */ (function (_super) {
    __extends(CreditPaymentsResource, _super);
    function CreditPaymentsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CreditPaymentsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/credit/payments",
            headers: params.headers,
            method: 'GET',
            query: {
                expand: params.expand,
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                order_number: params.order_number,
                sort: params.sort,
            },
        });
    };
    CreditPaymentsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/credit/payments",
            headers: params.headers,
            method: 'POST',
            query: {
                context: params.context,
                expand: params.expand,
            },
        });
    };
    CreditPaymentsResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/credit/payments/versions",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    CreditPaymentsResource.prototype.getByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/credit/payments/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'GET',
            query: {
                expand: params.expand,
            },
        });
    };
    CreditPaymentsResource.prototype.putByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/credit/payments/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'PUT',
            query: {
                context: params.context,
                expand: params.expand,
            },
        });
    };
    CreditPaymentsResource.prototype.deleteByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/credit/payments/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'DELETE',
            query: {
                context: params.context,
            },
        });
    };
    return CreditPaymentsResource;
}($Resource));
export { CreditPaymentsResource };
var DiscountRuleSettingsResource = /** @class */ (function (_super) {
    __extends(DiscountRuleSettingsResource, _super);
    function DiscountRuleSettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DiscountRuleSettingsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/discount/rule/settings",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
                status: params.status,
            },
        });
    };
    DiscountRuleSettingsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/discount/rule/settings",
            headers: params.headers,
            method: 'POST',
        });
    };
    DiscountRuleSettingsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/discount/rule/settings/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    DiscountRuleSettingsResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/discount/rule/settings/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'PUT',
        });
    };
    DiscountRuleSettingsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/discount/rule/settings/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return DiscountRuleSettingsResource;
}($Resource));
export { DiscountRuleSettingsResource };
var ExperiencesResource = /** @class */ (function (_super) {
    __extends(ExperiencesResource, _super);
    function ExperiencesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Search experiences. Always paginated.*/
    ExperiencesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences",
            headers: params.headers,
            method: 'GET',
            query: {
                context: params.context,
                currency: params.currency,
                id: params.id,
                ip: params.ip,
                key: params.key,
                limit: params.limit,
                name: params.name,
                offset: params.offset,
                q: params.q,
                region: params.region,
                shipping_configuration_key: params.shipping_configuration_key,
                sort: params.sort,
                status: params.status,
                subcatalog: params.subcatalog,
            },
        });
    };
    /*Add experience*/
    ExperiencesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences",
            headers: params.headers,
            method: 'POST',
            query: {
                context: params.context,
            },
        });
    };
    /*Formats the requested amount using the formatting settings for the experience.*/
    ExperiencesResource.prototype.getConversionsByBaseAndAmount = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/conversions/" + encodeURIComponent(params.base) + "/" + encodeURIComponent(params.amount),
            headers: params.headers,
            method: 'GET',
            query: {
                context: params.context,
                country: params.country,
                currency: params.currency,
                experience: params.experience,
                ip: params.ip,
            },
        });
    };
    /*Returns localized information about 1 or more items. The items will be localized based on the experience selected by the query parameters in the order of experience, then country, then ip address.*/
    ExperiencesResource.prototype.getItems = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/items",
            headers: params.headers,
            method: 'GET',
            query: {
                context: params.context,
                country: params.country,
                currency: params.currency,
                experience: params.experience,
                ip: params.ip,
                language: params.language,
                limit: params.limit,
                number: params.number,
                offset: params.offset,
                sort: params.sort,
                status: params.status,
            },
        });
    };
    /*Returns information about this item localized based on the query parameters*/
    ExperiencesResource.prototype.getItemsByNumber = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/items/" + encodeURIComponent(params.number),
            headers: params.headers,
            method: 'GET',
            query: {
                context: params.context,
                country: params.country,
                currency: params.currency,
                experience: params.experience,
                ip: params.ip,
                language: params.language,
            },
        });
    };
    /*Builds a query to search experiences*/
    ExperiencesResource.prototype.postQueryAndBuilders = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/query/builders",
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Provides visibility into recent changes of each object, including deletion*/
    ExperiencesResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/versions",
            headers: params.headers,
            method: 'GET',
            query: {
                context: params.context,
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    ExperiencesResource.prototype.getCurrencyAndFormatsByExperienceKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.experience_key) + "/currency/formats",
            headers: params.headers,
            method: 'GET',
            query: {
                context: params.context,
            },
        });
    };
    ExperiencesResource.prototype.putCurrencyAndFormatsByExperienceKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.experience_key) + "/currency/formats",
            headers: params.headers,
            method: 'PUT',
            query: {
                context: params.context,
            },
        });
    };
    /*Returns localized information about 0 or more items given a query for the specified experience.*/
    ExperiencesResource.prototype.getLocalAndItemsByExperienceKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.experience_key) + "/local/items",
            headers: params.headers,
            method: 'GET',
            query: {
                context: params.context,
                currency: params.currency,
                q: params.q,
            },
        });
    };
    ExperiencesResource.prototype.getLogisticsAndSummaryByExperienceKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.experience_key) + "/logistics/summary",
            headers: params.headers,
            method: 'GET',
            query: {
                country: params.country,
                currency: params.currency,
                number: params.number,
            },
        });
    };
    ExperiencesResource.prototype.getMarginsByExperienceKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.experience_key) + "/margins",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    ExperiencesResource.prototype.postMarginsByExperienceKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.experience_key) + "/margins",
            headers: params.headers,
            method: 'POST',
        });
    };
    ExperiencesResource.prototype.getMarginsAndVersionsByExperienceKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.experience_key) + "/margins/versions",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    ExperiencesResource.prototype.getMarginsByExperienceKeyAndKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.experience_key) + "/margins/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'GET',
        });
    };
    ExperiencesResource.prototype.putMarginsByExperienceKeyAndKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.experience_key) + "/margins/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'PUT',
        });
    };
    ExperiencesResource.prototype.deleteMarginsByExperienceKeyAndKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.experience_key) + "/margins/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    ExperiencesResource.prototype.getPaymentMethodTypesByExperienceKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.experience_key) + "/payment-method-types",
            headers: params.headers,
            method: 'GET',
            query: {
                context: params.context,
                limit: params.limit,
                offset: params.offset,
            },
        });
    };
    ExperiencesResource.prototype.getPaymentAndMethodAndRulesByExperienceKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.experience_key) + "/payment/method/rules",
            headers: params.headers,
            method: 'GET',
            query: {
                amount: params.amount,
                context: params.context,
                currency: params.currency,
                payment_method_type: params.payment_method_type,
                tags: params.tags,
            },
        });
    };
    /*Change the ordering or payment tags for an experience. Every post must include one entry for each payment method offered by Flow.*/
    ExperiencesResource.prototype.putPaymentAndMethodAndRulesByExperienceKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.experience_key) + "/payment/method/rules",
            headers: params.headers,
            method: 'PUT',
            query: {
                context: params.context,
            },
        });
    };
    ExperiencesResource.prototype.getPriceAndBooksByExperienceKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.experience_key) + "/price/books",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                price_book_key: params.price_book_key,
                sort: params.sort,
            },
        });
    };
    ExperiencesResource.prototype.postPriceAndBooksByExperienceKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.experience_key) + "/price/books",
            headers: params.headers,
            method: 'POST',
            query: {
                context: params.context,
            },
        });
    };
    ExperiencesResource.prototype.putPriceAndBooksByExperienceKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.experience_key) + "/price/books",
            headers: params.headers,
            method: 'PUT',
            query: {
                context: params.context,
            },
        });
    };
    ExperiencesResource.prototype.getPriceAndBooksByExperienceKeyAndKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.experience_key) + "/price/books/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'GET',
        });
    };
    ExperiencesResource.prototype.deletePriceAndBooksByExperienceKeyAndKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.experience_key) + "/price/books/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    /*Returns information about a specific experience.*/
    ExperiencesResource.prototype.getByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'GET',
            query: {
                context: params.context,
            },
        });
    };
    /*Update experience with the specified key, creating if it does not exist.*/
    ExperiencesResource.prototype.putByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'PUT',
            query: {
                context: params.context,
            },
        });
    };
    /*Delete the experience with this key*/
    ExperiencesResource.prototype.deleteByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'DELETE',
            query: {
                context: params.context,
            },
        });
    };
    /*Clones the experience with the specified key, using data from experience_clone_form.*/
    ExperiencesResource.prototype.postCloneByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.key) + "/clone",
            headers: params.headers,
            method: 'POST',
            query: {
                context: params.context,
            },
        });
    };
    /*Returns the experience_clone associated with the id.*/
    ExperiencesResource.prototype.getCloneByKeyAndId = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.key) + "/clone/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Returns detailed information on the pricing of this item within this experience*/
    ExperiencesResource.prototype.getItemsAndPriceByKeyAndNumber = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.key) + "/items/" + encodeURIComponent(params.number) + "/price",
            headers: params.headers,
            method: 'GET',
            query: {
                context: params.context,
                currency: params.currency,
                price_amount: params.price_amount,
                price_currency: params.price_currency,
                ship_from_country: params.ship_from_country,
                ship_from_province: params.ship_from_province,
                ship_to_country: params.ship_to_country,
                ship_to_province: params.ship_to_province,
            },
        });
    };
    /*Get the pricing settings for this experience*/
    ExperiencesResource.prototype.getPricingByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.key) + "/pricing",
            headers: params.headers,
            method: 'GET',
            query: {
                context: params.context,
            },
        });
    };
    /*Update the pricing settings for this experience*/
    ExperiencesResource.prototype.putPricingByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.key) + "/pricing",
            headers: params.headers,
            method: 'PUT',
            query: {
                context: params.context,
            },
        });
    };
    /*Get available promotions for the experience*/
    ExperiencesResource.prototype.getPromotionsAndAvailableByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.key) + "/promotions/available",
            headers: params.headers,
            method: 'GET',
            query: {
                context: params.context,
            },
        });
    };
    /*Updates the status of a given experience.*/
    ExperiencesResource.prototype.putStatusByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.key) + "/status",
            headers: params.headers,
            method: 'PUT',
            query: {
                context: params.context,
            },
        });
    };
    return ExperiencesResource;
}($Resource));
export { ExperiencesResource };
var ExperienceCheckoutSettingsResource = /** @class */ (function (_super) {
    __extends(ExperienceCheckoutSettingsResource, _super);
    function ExperienceCheckoutSettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExperienceCheckoutSettingsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.experience_key) + "/settings/checkout",
            headers: params.headers,
            method: 'GET',
            query: {
                context: params.context,
            },
        });
    };
    ExperienceCheckoutSettingsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.experience_key) + "/settings/checkout",
            headers: params.headers,
            method: 'PUT',
            query: {
                context: params.context,
            },
        });
    };
    return ExperienceCheckoutSettingsResource;
}($Resource));
export { ExperienceCheckoutSettingsResource };
var ExperienceDefaultsResource = /** @class */ (function (_super) {
    __extends(ExperienceDefaultsResource, _super);
    function ExperienceDefaultsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns recommended default settings when creating a new experience*/
    ExperienceDefaultsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experience/defaults",
            headers: params.headers,
            method: 'GET',
            query: {
                context: params.context,
                region_id: params.region_id,
            },
        });
    };
    return ExperienceDefaultsResource;
}($Resource));
export { ExperienceDefaultsResource };
var ExperienceLogisticsSettingsResource = /** @class */ (function (_super) {
    __extends(ExperienceLogisticsSettingsResource, _super);
    function ExperienceLogisticsSettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExperienceLogisticsSettingsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.experience_key) + "/settings/logistics",
            headers: params.headers,
            method: 'GET',
        });
    };
    ExperienceLogisticsSettingsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.experience_key) + "/settings/logistics",
            headers: params.headers,
            method: 'PUT',
            query: {
                context: params.context,
            },
        });
    };
    return ExperienceLogisticsSettingsResource;
}($Resource));
export { ExperienceLogisticsSettingsResource };
var ExperiencePriceConversionsResource = /** @class */ (function (_super) {
    __extends(ExperiencePriceConversionsResource, _super);
    function ExperiencePriceConversionsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Converts one or more prices from one currency to another*/
    ExperiencePriceConversionsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.experience_key) + "/conversions/price",
            headers: params.headers,
            method: 'GET',
            query: {
                amount: params.amount,
                base: params.base,
                local: params.local,
            },
        });
    };
    return ExperiencePriceConversionsResource;
}($Resource));
export { ExperiencePriceConversionsResource };
var ExperiencePriceFacetConversionsResource = /** @class */ (function (_super) {
    __extends(ExperiencePriceFacetConversionsResource, _super);
    function ExperiencePriceFacetConversionsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Converts one or more price values into local currency, rounding for display in price facets. A common use case is to say show a price filter to consumers (e.g. 10-20 USD) and want to display that in local currency (15-30 CAD). To do so, send the values '10' and '20' to this API which will return the rounded local currency facet values*/
    ExperiencePriceFacetConversionsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.experience_key) + "/conversions/price/facet",
            headers: params.headers,
            method: 'GET',
            query: {
                base: params.base,
                local: params.local,
                max: params.max,
                min: params.min,
            },
        });
    };
    return ExperiencePriceFacetConversionsResource;
}($Resource));
export { ExperiencePriceFacetConversionsResource };
var ItemsResource = /** @class */ (function (_super) {
    __extends(ItemsResource, _super);
    function ItemsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Search items. Always paginated.*/
    ItemsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/catalog/items",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                number: params.number,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Add catalog item(s)*/
    ItemsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/catalog/items",
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Provides visibility into recent changes of each object, including deletion*/
    ItemsResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/catalog/items/versions",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                number: params.number,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Returns information about a specific item.*/
    ItemsResource.prototype.getByNumber = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/catalog/items/" + encodeURIComponent(params.number),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Update item with the specified number, creating if it does not exist.*/
    ItemsResource.prototype.putByNumber = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/catalog/items/" + encodeURIComponent(params.number),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Delete the item with this number*/
    ItemsResource.prototype.deleteByNumber = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/catalog/items/" + encodeURIComponent(params.number),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    /*Update item with the specified attributes.*/
    ItemsResource.prototype.patchAttributesByNumber = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/catalog/items/" + encodeURIComponent(params.number) + "/attributes",
            headers: params.headers,
            method: 'PATCH',
        });
    };
    /*Update item with the specified number, creating if it does not exist.*/
    ItemsResource.prototype.putPriceByNumber = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/catalog/items/" + encodeURIComponent(params.number) + "/price",
            headers: params.headers,
            method: 'PUT',
        });
    };
    return ItemsResource;
}($Resource));
export { ItemsResource };
var ItemFormOverlaysResource = /** @class */ (function (_super) {
    __extends(ItemFormOverlaysResource, _super);
    function ItemFormOverlaysResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ItemFormOverlaysResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/catalog/item/overlays",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Adds an overlay data to merge into a catalog item*/
    ItemFormOverlaysResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/catalog/item/overlays",
            headers: params.headers,
            method: 'POST',
        });
    };
    ItemFormOverlaysResource.prototype.getByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/catalog/item/overlays/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Update item overlay with the specified key, creating if it does not exist.*/
    ItemFormOverlaysResource.prototype.putByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/catalog/item/overlays/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'PUT',
        });
    };
    ItemFormOverlaysResource.prototype.deleteByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/catalog/item/overlays/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return ItemFormOverlaysResource;
}($Resource));
export { ItemFormOverlaysResource };
var OrdersResource = /** @class */ (function (_super) {
    __extends(OrdersResource, _super);
    function OrdersResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Search orders. Always paginated.*/
    OrdersResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/orders",
            headers: params.headers,
            method: 'GET',
            query: {
                context: params.context,
                customer_number: params.customer_number,
                expand: params.expand,
                id: params.id,
                identifier: params.identifier,
                limit: params.limit,
                number: params.number,
                offset: params.offset,
                romanize: params.romanize,
                sort: params.sort,
                status: params.status,
                submitted_at_on_or_after: params.submitted_at_on_or_after,
            },
        });
    };
    /*Create an order, using the localized information from the experience selected by the query parameters. Note the order must be submitted before its expiration*/
    OrdersResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/orders",
            headers: params.headers,
            method: 'POST',
            query: {
                context: params.context,
                country: params.country,
                currency: params.currency,
                expand: params.expand,
                experience: params.experience,
                ip: params.ip,
                language: params.language,
                romanize: params.romanize,
            },
        });
    };
    /*Returns information about a specific order using an identifier number*/
    OrdersResource.prototype.getIdentifierByIdentifier = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/orders/identifier/" + encodeURIComponent(params.identifier),
            headers: params.headers,
            method: 'GET',
            query: {
                context: params.context,
                expand: params.expand,
                romanize: params.romanize,
            },
        });
    };
    /*Submits an order. You will get a validation error if the order has already expired (and a new quote could not be automatically recreated for a lower or same price). This method is idempotent - submitting an order a second time has no effect.*/
    OrdersResource.prototype.postSubmissions = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/orders/submissions",
            headers: params.headers,
            method: 'POST',
            query: {
                context: params.context,
                currency: params.currency,
                expand: params.expand,
                experience: params.experience,
                show_selections_only: params.show_selections_only,
            },
        });
    };
    /*Provides visibility into recent changes of each order, including deletion*/
    OrdersResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/orders/versions",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                journal_timestamp_on_or_after: params.journal_timestamp_on_or_after,
                limit: params.limit,
                number: params.number,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Returns information about a specific order.*/
    OrdersResource.prototype.getByNumber = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/orders/" + encodeURIComponent(params.number),
            headers: params.headers,
            method: 'GET',
            query: {
                context: params.context,
                expand: params.expand,
                romanize: params.romanize,
            },
        });
    };
    /*Upserts an order. using the localized information from the experience selected by the query parameters. Note the order must be submitted before its expiration*/
    OrdersResource.prototype.putByNumber = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/orders/" + encodeURIComponent(params.number),
            headers: params.headers,
            method: 'PUT',
            query: {
                context: params.context,
                country: params.country,
                currency: params.currency,
                expand: params.expand,
                experience: params.experience,
                ip: params.ip,
                language: params.language,
                romanize: params.romanize,
            },
        });
    };
    /*Delete an order. Note that production orders that have already been submitted cannot be deleted (you will see a 422 response in these cases).*/
    OrdersResource.prototype.deleteByNumber = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/orders/" + encodeURIComponent(params.number),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    /*Order allocations provide a granular view of an order that is targeted for accounting / financial views of an order*/
    OrdersResource.prototype.getAllocationsByNumber = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/orders/" + encodeURIComponent(params.number) + "/allocations",
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Creates an authorization, automatically associating to this order.*/
    OrdersResource.prototype.postAuthorizationsByNumber = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/orders/" + encodeURIComponent(params.number) + "/authorizations",
            headers: params.headers,
            method: 'POST',
            query: {
                context: params.context,
            },
        });
    };
    /*Updates an order's destination address*/
    OrdersResource.prototype.putDestinationByNumber = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/orders/" + encodeURIComponent(params.number) + "/destination",
            headers: params.headers,
            method: 'PUT',
            query: {
                context: params.context,
            },
        });
    };
    OrdersResource.prototype.putInventoryAndReservationsByNumber = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/orders/" + encodeURIComponent(params.number) + "/inventory/reservations",
            headers: params.headers,
            method: 'PUT',
            query: {
                context: params.context,
            },
        });
    };
    /*Creates an order payment by applying the authorization to the order.*/
    OrdersResource.prototype.postPaymentsByNumber = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/orders/" + encodeURIComponent(params.number) + "/payments",
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Creates a free shipping promotion for this order, automatically applying it to the order if the order meets the defined promotion trigger.*/
    OrdersResource.prototype.putPromotionsAndFreeShippingByNumberAndKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/orders/" + encodeURIComponent(params.number) + "/promotions/" + encodeURIComponent(params.key) + "/free_shipping",
            headers: params.headers,
            method: 'PUT',
            query: {
                context: params.context,
                expand: params.expand,
            },
        });
    };
    OrdersResource.prototype.postServiceAndChangesByNumber = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/orders/" + encodeURIComponent(params.number) + "/service/changes",
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Submits an order. You will get a validation error if the order has already expired (and a new quote could not be automatically recreated for a lower or same price). This method is idempotent - submitting an order a second time has no effect.*/
    OrdersResource.prototype.putSubmissionsByNumber = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/orders/" + encodeURIComponent(params.number) + "/submissions",
            headers: params.headers,
            method: 'PUT',
            query: {
                context: params.context,
                expand: params.expand,
            },
        });
    };
    /*Validates a tax registration number, proxying to underlying services and recording the result on the order.*/
    OrdersResource.prototype.putTaxAndRegistrationByNumber = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/orders/" + encodeURIComponent(params.number) + "/tax/registration",
            headers: params.headers,
            method: 'PUT',
            query: {
                context: params.context,
            },
        });
    };
    OrdersResource.prototype.deleteTaxAndRegistrationByNumberAndKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/orders/" + encodeURIComponent(params.number) + "/tax/registration/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    /*Retrieve the current fraud status for an order.*/
    OrdersResource.prototype.getStatusAndFraudByNumber = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/orders/" + encodeURIComponent(params.number) + "/status/fraud",
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Generate a commercial invoice for the order without providing a label.*/
    OrdersResource.prototype.postLabelsAndDocumentsAndInvoiceByNumber = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/orders/" + encodeURIComponent(params.number) + "/labels/documents/invoice",
            headers: params.headers,
            method: 'POST',
        });
    };
    return OrdersResource;
}($Resource));
export { OrdersResource };
var OrderBuildersResource = /** @class */ (function (_super) {
    __extends(OrderBuildersResource, _super);
    function OrderBuildersResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrderBuildersResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/order/builders",
            headers: params.headers,
            method: 'POST',
            query: {
                context: params.context,
                country: params.country,
                currency: params.currency,
                expand: params.expand,
                experience: params.experience,
                ip: params.ip,
                language: params.language,
            },
        });
    };
    OrderBuildersResource.prototype.putCartsByNumber = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/order/builders/carts/" + encodeURIComponent(params.number),
            headers: params.headers,
            method: 'PUT',
            query: {
                context: params.context,
                country: params.country,
                currency: params.currency,
                expand: params.expand,
                experience: params.experience,
                ip: params.ip,
                language: params.language,
            },
        });
    };
    /*Returns information about a specific order and any errors associated with the order.*/
    OrderBuildersResource.prototype.getByNumber = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/order/builders/" + encodeURIComponent(params.number),
            headers: params.headers,
            method: 'GET',
            query: {
                context: params.context,
                expand: params.expand,
                romanize: params.romanize,
            },
        });
    };
    OrderBuildersResource.prototype.putByNumber = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/order/builders/" + encodeURIComponent(params.number),
            headers: params.headers,
            method: 'PUT',
            query: {
                context: params.context,
                country: params.country,
                currency: params.currency,
                expand: params.expand,
                experience: params.experience,
                ip: params.ip,
                language: params.language,
            },
        });
    };
    OrderBuildersResource.prototype.putAttributesByNumber = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/order/builders/" + encodeURIComponent(params.number) + "/attributes",
            headers: params.headers,
            method: 'PUT',
            query: {
                context: params.context,
                expand: params.expand,
            },
        });
    };
    OrderBuildersResource.prototype.putCountryByNumber = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/order/builders/" + encodeURIComponent(params.number) + "/country",
            headers: params.headers,
            method: 'PUT',
            query: {
                context: params.context,
                expand: params.expand,
            },
        });
    };
    OrderBuildersResource.prototype.putDestinationByNumber = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/order/builders/" + encodeURIComponent(params.number) + "/destination",
            headers: params.headers,
            method: 'PUT',
            query: {
                context: params.context,
                expand: params.expand,
            },
        });
    };
    OrderBuildersResource.prototype.putDutyByNumber = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/order/builders/" + encodeURIComponent(params.number) + "/duty",
            headers: params.headers,
            method: 'PUT',
            query: {
                context: params.context,
                expand: params.expand,
            },
        });
    };
    /*Update the customer invoice address*/
    OrderBuildersResource.prototype.putInvoiceAndAddressByNumber = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/order/builders/" + encodeURIComponent(params.number) + "/invoice/address",
            headers: params.headers,
            method: 'PUT',
            query: {
                context: params.context,
                expand: params.expand,
            },
        });
    };
    /*Adds a line item to the order.*/
    OrderBuildersResource.prototype.postLinesByNumber = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/order/builders/" + encodeURIComponent(params.number) + "/lines",
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Replaces all line items in the order.*/
    OrderBuildersResource.prototype.putLinesByNumber = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/order/builders/" + encodeURIComponent(params.number) + "/lines",
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Replaces line item in the order specifed by the line item id.*/
    OrderBuildersResource.prototype.putLinesByNumberAndId = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/order/builders/" + encodeURIComponent(params.number) + "/lines/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Deletes line item in the order specifed by the line item id.*/
    OrderBuildersResource.prototype.deleteLinesByNumberAndId = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/order/builders/" + encodeURIComponent(params.number) + "/lines/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    /*Updates line item attributes in the order specifed by the line item id.*/
    OrderBuildersResource.prototype.putLinesAndAttributesByNumberAndId = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/order/builders/" + encodeURIComponent(params.number) + "/lines/" + encodeURIComponent(params.id) + "/attributes",
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Updates line item quantity in the order specifed by the line item id.*/
    OrderBuildersResource.prototype.putLinesAndQuantityByNumberAndId = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/order/builders/" + encodeURIComponent(params.number) + "/lines/" + encodeURIComponent(params.id) + "/quantity",
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Validates a tax registration number, proxying to underlying services and recording the result on the order.*/
    OrderBuildersResource.prototype.putTaxAndRegistrationByNumber = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/order/builders/" + encodeURIComponent(params.number) + "/tax/registration",
            headers: params.headers,
            method: 'PUT',
            query: {
                context: params.context,
                expand: params.expand,
            },
        });
    };
    return OrderBuildersResource;
}($Resource));
export { OrderBuildersResource };
var OrderEstimatesResource = /** @class */ (function (_super) {
    __extends(OrderEstimatesResource, _super);
    function OrderEstimatesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Create an order estimate, using the localized information from the experience selected by the query parameters. This is similar to the POST orders endpoint, except this just returns an estimate and cannot be submitted.*/
    OrderEstimatesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/order-estimates",
            headers: params.headers,
            method: 'POST',
            query: {
                context: params.context,
                country: params.country,
                currency: params.currency,
                expand: params.expand,
                experience: params.experience,
                ip: params.ip,
                language: params.language,
                romanize: params.romanize,
            },
        });
    };
    OrderEstimatesResource.prototype.getByNumber = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/order-estimates/" + encodeURIComponent(params.number),
            headers: params.headers,
            method: 'GET',
            query: {
                context: params.context,
                expand: params.expand,
                romanize: params.romanize,
            },
        });
    };
    OrderEstimatesResource.prototype.putByNumber = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/order-estimates/" + encodeURIComponent(params.number),
            headers: params.headers,
            method: 'PUT',
            query: {
                context: params.context,
                country: params.country,
                currency: params.currency,
                expand: params.expand,
                experience: params.experience,
                ip: params.ip,
                language: params.language,
                romanize: params.romanize,
            },
        });
    };
    return OrderEstimatesResource;
}($Resource));
export { OrderEstimatesResource };
var OrderIdentifiersResource = /** @class */ (function (_super) {
    __extends(OrderIdentifiersResource, _super);
    function OrderIdentifiersResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrderIdentifiersResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/order-identifiers",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                identifier: params.identifier,
                limit: params.limit,
                offset: params.offset,
                order_number: params.order_number,
                sort: params.sort,
            },
        });
    };
    OrderIdentifiersResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/order-identifiers",
            headers: params.headers,
            method: 'POST',
        });
    };
    OrderIdentifiersResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/order-identifiers/versions",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    OrderIdentifiersResource.prototype.getByIdentifier = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/order-identifiers/" + encodeURIComponent(params.identifier),
            headers: params.headers,
            method: 'GET',
        });
    };
    OrderIdentifiersResource.prototype.putByIdentifier = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/order-identifiers/" + encodeURIComponent(params.identifier),
            headers: params.headers,
            method: 'PUT',
        });
    };
    OrderIdentifiersResource.prototype.deleteByIdentifier = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/order-identifiers/" + encodeURIComponent(params.identifier),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return OrderIdentifiersResource;
}($Resource));
export { OrderIdentifiersResource };
var OrderNumberGeneratorsResource = /** @class */ (function (_super) {
    __extends(OrderNumberGeneratorsResource, _super);
    function OrderNumberGeneratorsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrderNumberGeneratorsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/order/number/generators",
            headers: params.headers,
            method: 'GET',
        });
    };
    OrderNumberGeneratorsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/order/number/generators",
            headers: params.headers,
            method: 'PUT',
        });
    };
    OrderNumberGeneratorsResource.prototype.delete = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/order/number/generators",
            headers: params.headers,
            method: 'DELETE',
        });
    };
    OrderNumberGeneratorsResource.prototype.getGeneratedAndNumber = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/order/number/generators/generated/number",
            headers: params.headers,
            method: 'GET',
        });
    };
    return OrderNumberGeneratorsResource;
}($Resource));
export { OrderNumberGeneratorsResource };
var OrderPromotionsResource = /** @class */ (function (_super) {
    __extends(OrderPromotionsResource, _super);
    function OrderPromotionsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Deletes the order promotion with the specified key*/
    OrderPromotionsResource.prototype.deleteByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/order/promotions/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return OrderPromotionsResource;
}($Resource));
export { OrderPromotionsResource };
var OrderSummariesResource = /** @class */ (function (_super) {
    __extends(OrderSummariesResource, _super);
    function OrderSummariesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrderSummariesResource.prototype.getByNumber = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/order/summaries/" + encodeURIComponent(params.number),
            headers: params.headers,
            method: 'GET',
        });
    };
    return OrderSummariesResource;
}($Resource));
export { OrderSummariesResource };
var OrganizationsResource = /** @class */ (function (_super) {
    __extends(OrganizationsResource, _super);
    function OrganizationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*The countries resources provides a unique list of all of the countries for which an experience exists. We generate this list of countries by iterating through all of the experience regions, and collecting all of the countries.*/
    OrganizationsResource.prototype.getCountriesByOrganization = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/countries",
            headers: params.headers,
            method: 'GET',
            query: {
                context: params.context,
                country: params.country,
                ip: params.ip,
                status: params.status,
            },
        });
    };
    /*List of all destination countries available for this organization, including countries within a world experience.*/
    OrganizationsResource.prototype.getCountriesAndDestinationsByOrganization = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/countries/destinations",
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Status of all countries*/
    OrganizationsResource.prototype.getCountriesAndStatusesByOrganization = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/countries/statuses",
            headers: params.headers,
            method: 'GET',
        });
    };
    OrganizationsResource.prototype.putCountriesAndStatusesByOrganizationAndCountry = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/countries/statuses/" + encodeURIComponent(params.country),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Search organizations. Always paginated.*/
    OrganizationsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/organizations',
            headers: params.headers,
            method: 'GET',
            query: {
                environment: params.environment,
                id: params.id,
                limit: params.limit,
                name: params.name,
                offset: params.offset,
                parent: params.parent,
                sort: params.sort,
            },
        });
    };
    /*Create a new organization.*/
    OrganizationsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/organizations',
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Provides visibility into recent changes of each object, including deletion*/
    OrganizationsResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: '/organizations/versions',
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                organization: params.organization,
                sort: params.sort,
            },
        });
    };
    /*Returns information about a specific organization.*/
    OrganizationsResource.prototype.getByOrganizationId = function (params) {
        return this.client.request({
            endpoint: "/organizations/" + encodeURIComponent(params.organization_id),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Update or create an organization with the specified id.*/
    OrganizationsResource.prototype.putByOrganizationId = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/organizations/" + encodeURIComponent(params.organization_id),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Delete the organization with this id*/
    OrganizationsResource.prototype.deleteByOrganizationId = function (params) {
        return this.client.request({
            endpoint: "/organizations/" + encodeURIComponent(params.organization_id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    /*Returns currencies for a specific organization.*/
    OrganizationsResource.prototype.getSettingsAndCurrenciesByOrganizationId = function (params) {
        return this.client.request({
            endpoint: "/organizations/" + encodeURIComponent(params.organization_id) + "/settings/currencies",
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Returns the region settings associated to a specific organization.*/
    OrganizationsResource.prototype.getSettingsAndRegionsByOrganizationId = function (params) {
        return this.client.request({
            endpoint: "/organizations/" + encodeURIComponent(params.organization_id) + "/settings/regions",
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Returns the list of enabled countries based on the region settings for a specific organization*/
    OrganizationsResource.prototype.getSettingsAndRegionsAndCountriesAndAvailableByOrganizationId = function (params) {
        return this.client.request({
            endpoint: "/organizations/" + encodeURIComponent(params.organization_id) + "/settings/regions/countries/available",
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Updates or creates a region setting for a specific organization*/
    OrganizationsResource.prototype.putSettingsAndRegionsByOrganizationIdAndRegion = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/organizations/" + encodeURIComponent(params.organization_id) + "/settings/regions/" + encodeURIComponent(params.region),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Removes the setting for this region for a specific organization*/
    OrganizationsResource.prototype.deleteSettingsAndRegionsByOrganizationIdAndRegion = function (params) {
        return this.client.request({
            endpoint: "/organizations/" + encodeURIComponent(params.organization_id) + "/settings/regions/" + encodeURIComponent(params.region),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return OrganizationsResource;
}($Resource));
export { OrganizationsResource };
var PaymentMethodRulesResource = /** @class */ (function (_super) {
    __extends(PaymentMethodRulesResource, _super);
    function PaymentMethodRulesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PaymentMethodRulesResource.prototype.getPaymentMethodRules = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/payment-method-rules",
            headers: params.headers,
            method: 'GET',
            query: {
                amount: params.amount,
                context: params.context,
                country: params.country,
                currency: params.currency,
                experience: params.experience,
                ip: params.ip,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    PaymentMethodRulesResource.prototype.getPaymentAndMethodAndRules = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/payment/method/rules",
            headers: params.headers,
            method: 'GET',
            query: {
                amount: params.amount,
                context: params.context,
                country: params.country,
                currency: params.currency,
                experience: params.experience,
                ip: params.ip,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Provides payment method rules for all experiences for an organization*/
    PaymentMethodRulesResource.prototype.getPaymentAndMethodAndRulesAndBatch = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/payment/method/rules/batch",
            headers: params.headers,
            method: 'GET',
            query: {
                context: params.context,
                experiences: params.experiences,
                limit: params.limit,
                offset: params.offset,
            },
        });
    };
    return PaymentMethodRulesResource;
}($Resource));
export { PaymentMethodRulesResource };
var PriceBooksResource = /** @class */ (function (_super) {
    __extends(PriceBooksResource, _super);
    function PriceBooksResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PriceBooksResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/price/books",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Create a price book.*/
    PriceBooksResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/price/books",
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Returns information about a specific price book.*/
    PriceBooksResource.prototype.getByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/price/books/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Create or update a price book.*/
    PriceBooksResource.prototype.putByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/price/books/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Deletes the specified price book*/
    PriceBooksResource.prototype.deleteByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/price/books/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return PriceBooksResource;
}($Resource));
export { PriceBooksResource };
var PriceBookItemsResource = /** @class */ (function (_super) {
    __extends(PriceBookItemsResource, _super);
    function PriceBookItemsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PriceBookItemsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/price/books/" + encodeURIComponent(params.price_book_key) + "/items",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                key: params.key,
                limit: params.limit,
                number: params.number,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Create a price book item.*/
    PriceBookItemsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/price/books/" + encodeURIComponent(params.price_book_key) + "/items",
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Returns information about a specific price book item.*/
    PriceBookItemsResource.prototype.getByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/price/books/" + encodeURIComponent(params.price_book_key) + "/items/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Create or update a price book item.*/
    PriceBookItemsResource.prototype.putByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/price/books/" + encodeURIComponent(params.price_book_key) + "/items/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Deletes the specified price book item*/
    PriceBookItemsResource.prototype.deleteByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/price/books/" + encodeURIComponent(params.price_book_key) + "/items/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return PriceBookItemsResource;
}($Resource));
export { PriceBookItemsResource };
var SubcatalogsResource = /** @class */ (function (_super) {
    __extends(SubcatalogsResource, _super);
    function SubcatalogsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Search subcatalogs. Always paginated.*/
    SubcatalogsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/catalog/subcatalogs",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Add subcatalog*/
    SubcatalogsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/catalog/subcatalogs",
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Provides visibility into recent changes of each object, including deletion*/
    SubcatalogsResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/catalog/subcatalogs/versions",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Returns information about a specific subcatalog.*/
    SubcatalogsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/catalog/subcatalogs/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Update subcatalog with the specified id, creating if it does not exist.*/
    SubcatalogsResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/catalog/subcatalogs/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Delete the subcatalog with this id*/
    SubcatalogsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/catalog/subcatalogs/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    /*Returns information about a specific subcatalog's settings.*/
    SubcatalogsResource.prototype.getSettingsById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/catalog/subcatalogs/" + encodeURIComponent(params.id) + "/settings",
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Update subcatalog settings for the specified subcatalog.*/
    SubcatalogsResource.prototype.putSettingsById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/catalog/subcatalogs/" + encodeURIComponent(params.id) + "/settings",
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Get statistics for the specified subcatalog*/
    SubcatalogsResource.prototype.getStatisticsBySubcatalogId = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/catalog/subcatalogs/" + encodeURIComponent(params.subcatalog_id) + "/statistics",
            headers: params.headers,
            method: 'GET',
        });
    };
    return SubcatalogsResource;
}($Resource));
export { SubcatalogsResource };
var SubcatalogItemsResource = /** @class */ (function (_super) {
    __extends(SubcatalogItemsResource, _super);
    function SubcatalogItemsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Search subcatalog items. Always paginated.*/
    SubcatalogItemsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/catalog/subcatalogs/" + encodeURIComponent(params.subcatalog_id) + "/items",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                number: params.number,
                offset: params.offset,
                sort: params.sort,
                status: params.status,
            },
        });
    };
    /*Provides visibility into recent changes of each object, including deletion*/
    SubcatalogItemsResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/catalog/subcatalogs/" + encodeURIComponent(params.subcatalog_id) + "/items/versions",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                number: params.number,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Returns information about specific subcatalog items.*/
    SubcatalogItemsResource.prototype.getByNumber = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/catalog/subcatalogs/" + encodeURIComponent(params.subcatalog_id) + "/items/" + encodeURIComponent(params.number),
            headers: params.headers,
            method: 'GET',
        });
    };
    return SubcatalogItemsResource;
}($Resource));
export { SubcatalogItemsResource };
var RatesResource = /** @class */ (function (_super) {
    __extends(RatesResource, _super);
    function RatesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Search organization currency conversion rates. Always paginated.*/
    RatesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/currency/rates",
            headers: params.headers,
            method: 'GET',
            query: {
                base: params.base,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
                target: params.target,
            },
        });
    };
    /*Provides visibility into recent changes of each object, including deletion.*/
    RatesResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/currency/rates/versions",
            headers: params.headers,
            method: 'GET',
            query: {
                base: params.base,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
                target: params.target,
            },
        });
    };
    return RatesResource;
}($Resource));
export { RatesResource };
var HarmonizedLandedCostsResource = /** @class */ (function (_super) {
    __extends(HarmonizedLandedCostsResource, _super);
    function HarmonizedLandedCostsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Single operation that provides harmonization landed costs (i.e. duties and taxes) for 1 or more items. This method is designed to enable a single call from applications that need it (like checkout) to get all data for a collection of items*/
    HarmonizedLandedCostsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/harmonization/landed-costs",
            headers: params.headers,
            method: 'POST',
        });
    };
    return HarmonizedLandedCostsResource;
}($Resource));
export { HarmonizedLandedCostsResource };
var Hs10Resource = /** @class */ (function (_super) {
    __extends(Hs10Resource, _super);
    function Hs10Resource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Hs10Resource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/harmonization/hs10",
            headers: params.headers,
            method: 'GET',
            query: {
                code: params.code,
                destination: params.destination,
                id: params.id,
                item_number: params.item_number,
                limit: params.limit,
                offset: params.offset,
                origin: params.origin,
            },
        });
    };
    return Hs10Resource;
}($Resource));
export { Hs10Resource };
var TaxRegistrationsResource = /** @class */ (function (_super) {
    __extends(TaxRegistrationsResource, _super);
    function TaxRegistrationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TaxRegistrationsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/tax/registrations",
            headers: params.headers,
            method: 'POST',
        });
    };
    TaxRegistrationsResource.prototype.getDetails = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/tax/registrations/details",
            headers: params.headers,
            method: 'GET',
            query: {
                limit: params.limit,
                offset: params.offset,
                order_number: params.order_number,
            },
        });
    };
    TaxRegistrationsResource.prototype.putByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/tax/registrations/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'PUT',
        });
    };
    TaxRegistrationsResource.prototype.deleteByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/tax/registrations/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return TaxRegistrationsResource;
}($Resource));
export { TaxRegistrationsResource };
var AuthorizationsResource = /** @class */ (function (_super) {
    __extends(AuthorizationsResource, _super);
    function AuthorizationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AuthorizationsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/authorizations",
            headers: params.headers,
            method: 'GET',
            query: {
                expand: params.expand,
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                order_number: params.order_number,
                sort: params.sort,
            },
        });
    };
    /*Create a new authorization.*/
    AuthorizationsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/authorizations",
            headers: params.headers,
            method: 'POST',
            query: {
                expand: params.expand,
            },
        });
    };
    /*Provides visibility into recent changes of each object, including deletion*/
    AuthorizationsResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/authorizations/versions",
            headers: params.headers,
            method: 'GET',
            query: {
                authorization_id: params.authorization_id,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Returns information about a specific authorization.*/
    AuthorizationsResource.prototype.getByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/authorizations/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'GET',
            query: {
                expand: params.expand,
            },
        });
    };
    /*Attempts to create an authorization identified by the provided key. Multiple requests using the same key are idempotent.*/
    AuthorizationsResource.prototype.putByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/authorizations/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'PUT',
            query: {
                expand: params.expand,
            },
        });
    };
    /*Deprecated. This end point no longer deletes an authorization and is implemented by creating a reversal for the remaining balance on the auth.*/
    AuthorizationsResource.prototype.deleteByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/authorizations/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    /*Accepts the data from the underlying processor to, for example, record the 3DSecure results*/
    AuthorizationsResource.prototype.postDetailsByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/authorizations/" + encodeURIComponent(params.key) + "/details",
            headers: params.headers,
            method: 'POST',
        });
    };
    return AuthorizationsResource;
}($Resource));
export { AuthorizationsResource };
var CapturesResource = /** @class */ (function (_super) {
    __extends(CapturesResource, _super);
    function CapturesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CapturesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/captures",
            headers: params.headers,
            method: 'GET',
            query: {
                authorization_id: params.authorization_id,
                authorization_key: params.authorization_key,
                id: params.id,
                identifier: params.identifier,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Create a new capture.*/
    CapturesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/captures",
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Provides visibility into recent changes of each object, including deletion*/
    CapturesResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/captures/versions",
            headers: params.headers,
            method: 'GET',
            query: {
                capture_id: params.capture_id,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Returns information about a specific capture.*/
    CapturesResource.prototype.getByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/captures/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'GET',
        });
    };
    CapturesResource.prototype.getIdentifiersByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/captures/" + encodeURIComponent(params.key) + "/identifiers",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                identifier: params.identifier,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Create a new identifier for this capture*/
    CapturesResource.prototype.putIdentifiersByKeyAndIdentifier = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/captures/" + encodeURIComponent(params.key) + "/identifiers/" + encodeURIComponent(params.identifier),
            headers: params.headers,
            method: 'PUT',
        });
    };
    CapturesResource.prototype.deleteIdentifiersByKeyAndIdentifier = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/captures/" + encodeURIComponent(params.key) + "/identifiers/" + encodeURIComponent(params.identifier),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return CapturesResource;
}($Resource));
export { CapturesResource };
var CardsResource = /** @class */ (function (_super) {
    __extends(CardsResource, _super);
    function CardsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/cards",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
                token: params.token,
            },
        });
    };
    /*Create a new card. Note that when using JSONP to submit a card, you do not need to authenticate.*/
    CardsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/cards",
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Creates a card from a one time nonce. Each nonce can be used at most once and you will receive a validation error if the nonce has already been exchanged.*/
    CardsResource.prototype.postNonces = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/cards/nonces",
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Provides visibility into recent changes of each object, including deletion*/
    CardsResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/cards/versions",
            headers: params.headers,
            method: 'GET',
            query: {
                card_id: params.card_id,
                card_token: params.card_token,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Returns information about a specific card.*/
    CardsResource.prototype.getByToken = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/cards/" + encodeURIComponent(params.token),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Deletes the specified card*/
    CardsResource.prototype.deleteByToken = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/cards/" + encodeURIComponent(params.token),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return CardsResource;
}($Resource));
export { CardsResource };
var CardPaymentSourcesResource = /** @class */ (function (_super) {
    __extends(CardPaymentSourcesResource, _super);
    function CardPaymentSourcesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardPaymentSourcesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/sources/payments/cards",
            headers: params.headers,
            method: 'GET',
            query: {
                customer_number: params.customer_number,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Create a new card payment source.*/
    CardPaymentSourcesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/sources/payments/cards",
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Returns information about a specific card payment source.*/
    CardPaymentSourcesResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/sources/payments/cards/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Update a card payment source.*/
    CardPaymentSourcesResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/sources/payments/cards/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Deletes the specified card payment source*/
    CardPaymentSourcesResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/sources/payments/cards/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return CardPaymentSourcesResource;
}($Resource));
export { CardPaymentSourcesResource };
var GatewayAuthenticationDataResource = /** @class */ (function (_super) {
    __extends(GatewayAuthenticationDataResource, _super);
    function GatewayAuthenticationDataResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Specify authentication data for payment processor*/
    GatewayAuthenticationDataResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/gateways/authentication",
            headers: params.headers,
            method: 'POST',
        });
    };
    return GatewayAuthenticationDataResource;
}($Resource));
export { GatewayAuthenticationDataResource };
var PaymentsResource = /** @class */ (function (_super) {
    __extends(PaymentsResource, _super);
    function PaymentsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PaymentsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/payments",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                payment_method: params.payment_method,
                sort: params.sort,
            },
        });
    };
    /*Create a new payment. Note that when using JSONP to submit a payment, you do not need to authenticate.*/
    PaymentsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/payments",
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Provides visibility into recent changes of each object, including deletion*/
    PaymentsResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/payments/versions",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                payment_id: params.payment_id,
                sort: params.sort,
            },
        });
    };
    /*Returns information about a specific payment.*/
    PaymentsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/payments/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Deletes the specified payment*/
    PaymentsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/payments/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return PaymentsResource;
}($Resource));
export { PaymentsResource };
var PublicKeysResource = /** @class */ (function (_super) {
    __extends(PublicKeysResource, _super);
    function PublicKeysResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns your public keys*/
    PublicKeysResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/encryption/keys",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Return the latest public key for an organization*/
    PublicKeysResource.prototype.getLatest = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/encryption/keys/latest",
            headers: params.headers,
            method: 'GET',
        });
    };
    return PublicKeysResource;
}($Resource));
export { PublicKeysResource };
var RefundsResource = /** @class */ (function (_super) {
    __extends(RefundsResource, _super);
    function RefundsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RefundsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/refunds",
            headers: params.headers,
            method: 'GET',
            query: {
                authorization_id: params.authorization_id,
                authorization_key: params.authorization_key,
                capture_id: params.capture_id,
                capture_key: params.capture_key,
                id: params.id,
                identifier: params.identifier,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Create a new refund.*/
    RefundsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/refunds",
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Returns a refund order summary for the specified order.*/
    RefundsResource.prototype.getSummaryByOrderNumber = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/refunds/summary/" + encodeURIComponent(params.order_number),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Provides visibility into recent changes of each object, including deletion*/
    RefundsResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/refunds/versions",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                refund_id: params.refund_id,
                sort: params.sort,
            },
        });
    };
    /*Returns information about a specific refund.*/
    RefundsResource.prototype.getByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/refunds/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'GET',
        });
    };
    RefundsResource.prototype.getIdentifiersByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/refunds/" + encodeURIComponent(params.key) + "/identifiers",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                identifier: params.identifier,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Create a new identifier for this refund*/
    RefundsResource.prototype.putIdentifiersByKeyAndIdentifier = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/refunds/" + encodeURIComponent(params.key) + "/identifiers/" + encodeURIComponent(params.identifier),
            headers: params.headers,
            method: 'PUT',
        });
    };
    RefundsResource.prototype.deleteIdentifiersByKeyAndIdentifier = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/refunds/" + encodeURIComponent(params.key) + "/identifiers/" + encodeURIComponent(params.identifier),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return RefundsResource;
}($Resource));
export { RefundsResource };
var ReversalsResource = /** @class */ (function (_super) {
    __extends(ReversalsResource, _super);
    function ReversalsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReversalsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/reversals",
            headers: params.headers,
            method: 'GET',
            query: {
                authorization_id: params.authorization_id,
                authorization_key: params.authorization_key,
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    ReversalsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/reversals",
            headers: params.headers,
            method: 'POST',
        });
    };
    ReversalsResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/reversals/versions",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                reversal_id: params.reversal_id,
                sort: params.sort,
            },
        });
    };
    ReversalsResource.prototype.getByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/reversals/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Try inserting or updating a new reversal. Useful for retrying pending reversals*/
    ReversalsResource.prototype.putByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/reversals/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return ReversalsResource;
}($Resource));
export { ReversalsResource };
var VirtualCardsResource = /** @class */ (function (_super) {
    __extends(VirtualCardsResource, _super);
    function VirtualCardsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Retrieve all the virtual credit cards that have been created matching selected criteria.*/
    VirtualCardsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/virtual/cards",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Retrieves a virtual credit card using your unique key used when creating the card. Note that the card number and cvv will not be returned by this request to maintain PCI compliance. If you have lost these details you will need to create a new card.*/
    VirtualCardsResource.prototype.getByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/virtual/cards/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Creates a new virtual credit card. The card number and cvv will only be returned once when creating the card to maintain PCI compliance. This end point is idempotent and subsequent calls with same key will return details for the previously created card.*/
    VirtualCardsResource.prototype.putAuthorizationsByKeyAndAuthorizationKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/virtual/cards/" + encodeURIComponent(params.key) + "/authorizations/" + encodeURIComponent(params.authorization_key),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return VirtualCardsResource;
}($Resource));
export { VirtualCardsResource };
var VirtualCardCapturesResource = /** @class */ (function (_super) {
    __extends(VirtualCardCapturesResource, _super);
    function VirtualCardCapturesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Retrieve all the virtual credit card captures that have been received for all issued cards matching selected criteria.*/
    VirtualCardCapturesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/virtual/card/captures",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Retrieve payment captures for a specific virtual credit card that has been previously issued.*/
    VirtualCardCapturesResource.prototype.getByVirtualCardId = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/virtual/card/captures/" + encodeURIComponent(params.virtual_card_id),
            headers: params.headers,
            method: 'GET',
        });
    };
    return VirtualCardCapturesResource;
}($Resource));
export { VirtualCardCapturesResource };
var VirtualCardRefundsResource = /** @class */ (function (_super) {
    __extends(VirtualCardRefundsResource, _super);
    function VirtualCardRefundsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Retrieve all the virtual credit card refunds that have been received for all issued cards matching selected criteria.*/
    VirtualCardRefundsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/virtual/card/refunds",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Retrieve payment refunds for a specific virtual credit card that has been previously issued.*/
    VirtualCardRefundsResource.prototype.getByVirtualCardId = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/virtual/card/refunds/" + encodeURIComponent(params.virtual_card_id),
            headers: params.headers,
            method: 'GET',
        });
    };
    return VirtualCardRefundsResource;
}($Resource));
export { VirtualCardRefundsResource };
var CentersResource = /** @class */ (function (_super) {
    __extends(CentersResource, _super);
    function CentersResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CentersResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/centers",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    CentersResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/centers",
            headers: params.headers,
            method: 'POST',
        });
    };
    CentersResource.prototype.postQuery = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/centers/query",
            headers: params.headers,
            method: 'POST',
        });
    };
    CentersResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/centers/versions",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    CentersResource.prototype.getByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/centers/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'GET',
        });
    };
    CentersResource.prototype.putByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/centers/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'PUT',
        });
    };
    CentersResource.prototype.deleteByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/centers/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return CentersResource;
}($Resource));
export { CentersResource };
var DeliveryWindowsResource = /** @class */ (function (_super) {
    __extends(DeliveryWindowsResource, _super);
    function DeliveryWindowsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Endpoint to request a delivery window. Requires some knowledge of origin (based on organization, center, or specified address string) and destination (based on ip, lat/long, or address string). Other attributes allow us to narrow down delivery windows even more such as service level to be used and timestamp of expected shipment date.*/
    DeliveryWindowsResource.prototype.getSummary = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/delivery-windows/summary",
            headers: params.headers,
            method: 'GET',
            query: {
                center: params.center,
                context: params.context,
                destination: params.destination,
                ip: params.ip,
                item_number: params.item_number,
                latitude: params.latitude,
                longitude: params.longitude,
                max_lead_days: params.max_lead_days,
                min_lead_days: params.min_lead_days,
                origin: params.origin,
                service: params.service,
                strategy: params.strategy,
            },
        });
    };
    /*Endpoint to request all delivery windows across multiple destinations.*/
    DeliveryWindowsResource.prototype.getSummaryAndAll = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/delivery-windows/summary/all",
            headers: params.headers,
            method: 'GET',
            query: {
                context: params.context,
                destination: params.destination,
                limit: params.limit,
                offset: params.offset,
            },
        });
    };
    return DeliveryWindowsResource;
}($Resource));
export { DeliveryWindowsResource };
var DimensionEstimatesResource = /** @class */ (function (_super) {
    __extends(DimensionEstimatesResource, _super);
    function DimensionEstimatesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DimensionEstimatesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/dimension-estimates",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    DimensionEstimatesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/dimension-estimates",
            headers: params.headers,
            method: 'POST',
        });
    };
    DimensionEstimatesResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/dimension-estimates/versions",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    DimensionEstimatesResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/dimension-estimates/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    DimensionEstimatesResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/dimension-estimates/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'PUT',
        });
    };
    DimensionEstimatesResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/dimension-estimates/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return DimensionEstimatesResource;
}($Resource));
export { DimensionEstimatesResource };
var InventoryRulesResource = /** @class */ (function (_super) {
    __extends(InventoryRulesResource, _super);
    function InventoryRulesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InventoryRulesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/inventory_rules",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    InventoryRulesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/inventory_rules",
            headers: params.headers,
            method: 'POST',
        });
    };
    InventoryRulesResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/inventory_rules/versions",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    return InventoryRulesResource;
}($Resource));
export { InventoryRulesResource };
var InventorySnapshotsResource = /** @class */ (function (_super) {
    __extends(InventorySnapshotsResource, _super);
    function InventorySnapshotsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InventorySnapshotsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/inventory_snapshots",
            headers: params.headers,
            method: 'GET',
            query: {
                center: params.center,
                id: params.id,
                item_number: params.item_number,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    InventorySnapshotsResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/inventory_snapshots/versions",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                inventory_snapshot: params.inventory_snapshot,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    InventorySnapshotsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/inventory_snapshots/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    return InventorySnapshotsResource;
}($Resource));
export { InventorySnapshotsResource };
var InventoryUpdatesResource = /** @class */ (function (_super) {
    __extends(InventoryUpdatesResource, _super);
    function InventoryUpdatesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InventoryUpdatesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/inventory_updates",
            headers: params.headers,
            method: 'GET',
            query: {
                center: params.center,
                id: params.id,
                item_number: params.item_number,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    InventoryUpdatesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/inventory_updates",
            headers: params.headers,
            method: 'POST',
        });
    };
    InventoryUpdatesResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/inventory_updates/versions",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                inventory_update: params.inventory_update,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    InventoryUpdatesResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/inventory_updates/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    return InventoryUpdatesResource;
}($Resource));
export { InventoryUpdatesResource };
var ManifestsResource = /** @class */ (function (_super) {
    __extends(ManifestsResource, _super);
    function ManifestsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ManifestsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/manifests",
            headers: params.headers,
            method: 'GET',
            query: {
                carrier_tracking_number: params.carrier_tracking_number,
                flow_tracking_number: params.flow_tracking_number,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                service: params.service,
                sort: params.sort,
            },
        });
    };
    /*Creates a new manifest/carrier BOL with specific tracking numbers*/
    ManifestsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/manifests",
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Generates a new manifest with all outstanding labels and redirects to a downloadable PDF of carrier-generated manifest or bill of lading (BOL). If no outstanding labels, this will generate a 422 error.*/
    ManifestsResource.prototype.getServicesAndOutstandingByService = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/manifests/services/" + encodeURIComponent(params.service) + "/outstanding",
            headers: params.headers,
            method: 'GET',
        });
    };
    ManifestsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/manifests/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    return ManifestsResource;
}($Resource));
export { ManifestsResource };
var QuotesResource = /** @class */ (function (_super) {
    __extends(QuotesResource, _super);
    function QuotesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Search quotes. Always paginated.*/
    QuotesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/quotes",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    QuotesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/quotes",
            headers: params.headers,
            method: 'POST',
            query: {
                context: params.context,
            },
        });
    };
    QuotesResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/quotes/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    return QuotesResource;
}($Resource));
export { QuotesResource };
var RatecardsResource = /** @class */ (function (_super) {
    __extends(RatecardsResource, _super);
    function RatecardsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RatecardsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/ratecards",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                number: params.number,
                offset: params.offset,
                service: params.service,
                sort: params.sort,
            },
        });
    };
    RatecardsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/ratecards",
            headers: params.headers,
            method: 'POST',
        });
    };
    RatecardsResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/ratecards/versions",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    RatecardsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/ratecards/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    RatecardsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/ratecards/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    RatecardsResource.prototype.putPublishById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/ratecards/" + encodeURIComponent(params.id) + "/publish",
            headers: params.headers,
            method: 'PUT',
        });
    };
    return RatecardsResource;
}($Resource));
export { RatecardsResource };
var RatecardEstimatesResource = /** @class */ (function (_super) {
    __extends(RatecardEstimatesResource, _super);
    function RatecardEstimatesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Endpoint to get shipment cost estimates based on applicable rate cards. An origin and destination address must be provided. Final amounts are based on either gravitational weight or dimensional weight. When estimating based off gravitational weight, the weight field must be set. When estimating based off dimensional weight, then length/width/depth must be set. For either one, the appropriate unit of measurement must be given.*/
    RatecardEstimatesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/ratecard_estimates",
            headers: params.headers,
            method: 'POST',
            query: {
                context: params.context,
            },
        });
    };
    /*Endpoint to get a summary of the shipment estimates based on applicable rate cards. An origin and destination country must be provided.*/
    RatecardEstimatesResource.prototype.postSummaries = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/ratecard_estimates/summaries",
            headers: params.headers,
            method: 'POST',
            query: {
                context: params.context,
            },
        });
    };
    return RatecardEstimatesResource;
}($Resource));
export { RatecardEstimatesResource };
var RatecardLanesResource = /** @class */ (function (_super) {
    __extends(RatecardLanesResource, _super);
    function RatecardLanesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RatecardLanesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/ratecard-lanes",
            headers: params.headers,
            method: 'GET',
            query: {
                delivered_duty: params.delivered_duty,
                destination: params.destination,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                origin: params.origin,
                ratecard_id: params.ratecard_id,
                ratecard_owner: params.ratecard_owner,
                service: params.service,
                sort: params.sort,
            },
        });
    };
    RatecardLanesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/ratecard-lanes",
            headers: params.headers,
            method: 'POST',
        });
    };
    RatecardLanesResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/ratecard-lanes/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    RatecardLanesResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/ratecard-lanes/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'PUT',
        });
    };
    RatecardLanesResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/ratecard-lanes/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return RatecardLanesResource;
}($Resource));
export { RatecardLanesResource };
var RatecardRatesResource = /** @class */ (function (_super) {
    __extends(RatecardRatesResource, _super);
    function RatecardRatesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RatecardRatesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/ratecards/" + encodeURIComponent(params.ratecard_id) + "/lanes/" + encodeURIComponent(params.lane_id) + "/rates",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
                weight: params.weight,
            },
        });
    };
    RatecardRatesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/ratecards/" + encodeURIComponent(params.ratecard_id) + "/lanes/" + encodeURIComponent(params.lane_id) + "/rates",
            headers: params.headers,
            method: 'POST',
        });
    };
    RatecardRatesResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/ratecards/" + encodeURIComponent(params.ratecard_id) + "/lanes/" + encodeURIComponent(params.lane_id) + "/rates/versions",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    RatecardRatesResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/ratecards/" + encodeURIComponent(params.ratecard_id) + "/lanes/" + encodeURIComponent(params.lane_id) + "/rates/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    RatecardRatesResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/ratecards/" + encodeURIComponent(params.ratecard_id) + "/lanes/" + encodeURIComponent(params.lane_id) + "/rates/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'PUT',
        });
    };
    return RatecardRatesResource;
}($Resource));
export { RatecardRatesResource };
var ReturnsResource = /** @class */ (function (_super) {
    __extends(ReturnsResource, _super);
    function ReturnsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReturnsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/returns",
            headers: params.headers,
            method: 'GET',
            query: {
                carrier_tracking_number: params.carrier_tracking_number,
                flow_tracking_number: params.flow_tracking_number,
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                order_number: params.order_number,
                service: params.service,
                sort: params.sort,
            },
        });
    };
    ReturnsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/returns",
            headers: params.headers,
            method: 'POST',
        });
    };
    ReturnsResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/returns/versions",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    ReturnsResource.prototype.getByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/returns/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'GET',
        });
    };
    ReturnsResource.prototype.putByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/returns/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'PUT',
        });
    };
    ReturnsResource.prototype.deleteByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/returns/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return ReturnsResource;
}($Resource));
export { ReturnsResource };
var ShippingConfigurationsResource = /** @class */ (function (_super) {
    __extends(ShippingConfigurationsResource, _super);
    function ShippingConfigurationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShippingConfigurationsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/shipping/configuration",
            headers: params.headers,
            method: 'GET',
            query: {
                expand: params.expand,
                experience: params.experience,
                id: params.id,
                key: params.key,
                limit: params.limit,
                name: params.name,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    ShippingConfigurationsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/shipping/configuration",
            headers: params.headers,
            method: 'POST',
        });
    };
    ShippingConfigurationsResource.prototype.getByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/shipping/configuration/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'GET',
            query: {
                expand: params.expand,
                experience: params.experience,
            },
        });
    };
    ShippingConfigurationsResource.prototype.putByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/shipping/configuration/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'PUT',
            query: {
                expand: params.expand,
            },
        });
    };
    ShippingConfigurationsResource.prototype.deleteByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/shipping/configuration/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    ShippingConfigurationsResource.prototype.getLanesByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/shipping/configuration/" + encodeURIComponent(params.key) + "/lanes",
            headers: params.headers,
            method: 'GET',
            query: {
                expand: params.expand,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                region: params.region,
                sort: params.sort,
            },
        });
    };
    ShippingConfigurationsResource.prototype.postLanesByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/shipping/configuration/" + encodeURIComponent(params.key) + "/lanes",
            headers: params.headers,
            method: 'POST',
            query: {
                expand: params.expand,
            },
        });
    };
    ShippingConfigurationsResource.prototype.getLanesByKeyAndId = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/shipping/configuration/" + encodeURIComponent(params.key) + "/lanes/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
            query: {
                expand: params.expand,
            },
        });
    };
    ShippingConfigurationsResource.prototype.putLanesByKeyAndId = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/shipping/configuration/" + encodeURIComponent(params.key) + "/lanes/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'PUT',
            query: {
                expand: params.expand,
            },
        });
    };
    ShippingConfigurationsResource.prototype.deleteLanesByKeyAndId = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/shipping/configuration/" + encodeURIComponent(params.key) + "/lanes/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    /*Endpoint to retrieve the default tier of a shipping lane*/
    ShippingConfigurationsResource.prototype.getLanesAndDefaultsAndTiersByKeyAndId = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/shipping/configuration/" + encodeURIComponent(params.key) + "/lanes/" + encodeURIComponent(params.id) + "/defaults/tiers",
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Endpoint to set or udpate the default tier of a shipping lane*/
    ShippingConfigurationsResource.prototype.putLanesAndDefaultsAndTiersByKeyAndId = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/shipping/configuration/" + encodeURIComponent(params.key) + "/lanes/" + encodeURIComponent(params.id) + "/defaults/tiers",
            headers: params.headers,
            method: 'PUT',
        });
    };
    return ShippingConfigurationsResource;
}($Resource));
export { ShippingConfigurationsResource };
var ShippingConfigurationCopiesResource = /** @class */ (function (_super) {
    __extends(ShippingConfigurationCopiesResource, _super);
    function ShippingConfigurationCopiesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShippingConfigurationCopiesResource.prototype.postByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/shipping/configuration/copies/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'POST',
        });
    };
    return ShippingConfigurationCopiesResource;
}($Resource));
export { ShippingConfigurationCopiesResource };
var ShippingLabelsResource = /** @class */ (function (_super) {
    __extends(ShippingLabelsResource, _super);
    function ShippingLabelsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShippingLabelsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/shipping_labels",
            headers: params.headers,
            method: 'GET',
            query: {
                carrier_tracking_number: params.carrier_tracking_number,
                flow_tracking_number: params.flow_tracking_number,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                order_number: params.order_number,
                service: params.service,
                show_commercial_invoice: params.show_commercial_invoice,
                sort: params.sort,
            },
        });
    };
    ShippingLabelsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/shipping_labels",
            headers: params.headers,
            method: 'POST',
            query: {
                context: params.context,
                force_new: params.force_new,
                show_commercial_invoice: params.show_commercial_invoice,
            },
        });
    };
    ShippingLabelsResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/shipping_labels/versions",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                label: params.label,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    ShippingLabelsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/shipping_labels/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    return ShippingLabelsResource;
}($Resource));
export { ShippingLabelsResource };
var ShippingNotificationsResource = /** @class */ (function (_super) {
    __extends(ShippingNotificationsResource, _super);
    function ShippingNotificationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShippingNotificationsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/shipping-notifications",
            headers: params.headers,
            method: 'GET',
            query: {
                carrier_tracking_number: params.carrier_tracking_number,
                flow_tracking_number: params.flow_tracking_number,
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                order_number: params.order_number,
                service: params.service,
                sort: params.sort,
            },
        });
    };
    ShippingNotificationsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/shipping-notifications",
            headers: params.headers,
            method: 'POST',
        });
    };
    ShippingNotificationsResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/shipping-notifications/versions",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    ShippingNotificationsResource.prototype.getByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/shipping-notifications/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'GET',
        });
    };
    ShippingNotificationsResource.prototype.putByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/shipping-notifications/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'PUT',
        });
    };
    ShippingNotificationsResource.prototype.deleteByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/shipping-notifications/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return ShippingNotificationsResource;
}($Resource));
export { ShippingNotificationsResource };
var SurchargeSettingsResource = /** @class */ (function (_super) {
    __extends(SurchargeSettingsResource, _super);
    function SurchargeSettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SurchargeSettingsResource.prototype.getDisplays = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/surcharge/settings/displays",
            headers: params.headers,
            method: 'GET',
        });
    };
    return SurchargeSettingsResource;
}($Resource));
export { SurchargeSettingsResource };
var TiersResource = /** @class */ (function (_super) {
    __extends(TiersResource, _super);
    function TiersResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TiersResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/tiers",
            headers: params.headers,
            method: 'GET',
            query: {
                direction: params.direction,
                expand: params.expand,
                experience: params.experience,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    TiersResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/tiers",
            headers: params.headers,
            method: 'POST',
        });
    };
    TiersResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/tiers/versions",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    TiersResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/tiers/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    TiersResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/tiers/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'PUT',
        });
    };
    TiersResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/tiers/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return TiersResource;
}($Resource));
export { TiersResource };
var TrackingsResource = /** @class */ (function (_super) {
    __extends(TrackingsResource, _super);
    function TrackingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Public endpoint to get all relevant information about a tracking, label(s) under it, and event(s) under those label(s)*/
    TrackingsResource.prototype.getTrackingsById = function (params) {
        return this.client.request({
            endpoint: "/trackings/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    TrackingsResource.prototype.getTrackingsByOrganization = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/trackings",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    TrackingsResource.prototype.postTrackingsByOrganization = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/trackings",
            headers: params.headers,
            method: 'POST',
        });
    };
    TrackingsResource.prototype.getTrackingsAndVersionsByOrganization = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/trackings/versions",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
                tracking_id: params.tracking_id,
            },
        });
    };
    return TrackingsResource;
}($Resource));
export { TrackingsResource };
var TrackingEventsResource = /** @class */ (function (_super) {
    __extends(TrackingEventsResource, _super);
    function TrackingEventsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TrackingEventsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/tracking-events",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
                tracking_id: params.tracking_id,
                tracking_label_id: params.tracking_label_id,
            },
        });
    };
    TrackingEventsResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/tracking-events/versions",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
                tracking_event_id: params.tracking_event_id,
            },
        });
    };
    TrackingEventsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/tracking-events/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    return TrackingEventsResource;
}($Resource));
export { TrackingEventsResource };
var TrackingLabelsResource = /** @class */ (function (_super) {
    __extends(TrackingLabelsResource, _super);
    function TrackingLabelsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TrackingLabelsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/tracking-labels",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
                tracking_id: params.tracking_id,
            },
        });
    };
    TrackingLabelsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/tracking-labels",
            headers: params.headers,
            method: 'POST',
        });
    };
    TrackingLabelsResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/tracking-labels/versions",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
                tracking_label_id: params.tracking_label_id,
            },
        });
    };
    TrackingLabelsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/tracking-labels/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    return TrackingLabelsResource;
}($Resource));
export { TrackingLabelsResource };
var WebhooksResource = /** @class */ (function (_super) {
    __extends(WebhooksResource, _super);
    function WebhooksResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns webhooks for an organization*/
    WebhooksResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/webhooks",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Create a new webhook*/
    WebhooksResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/webhooks",
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Returns information about a specific webhook*/
    WebhooksResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/webhooks/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Update an existing webhook*/
    WebhooksResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/webhooks/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Delete a webhook with the specified id*/
    WebhooksResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/webhooks/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return WebhooksResource;
}($Resource));
export { WebhooksResource };
var WebhookDeliveriesResource = /** @class */ (function (_super) {
    __extends(WebhookDeliveriesResource, _super);
    function WebhookDeliveriesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns deliveries for an organization's webhook*/
    WebhookDeliveriesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/webhook/deliveries",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
                webhook_id: params.webhook_id,
            },
        });
    };
    /*Returns information about a specific webhook delivery*/
    WebhookDeliveriesResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/webhook/deliveries/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Redeliver a webhook request. This created a new webhook request to requeue delivery*/
    WebhookDeliveriesResource.prototype.postRequestsById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/webhook/deliveries/" + encodeURIComponent(params.id) + "/requests",
            headers: params.headers,
            method: 'POST',
        });
    };
    return WebhookDeliveriesResource;
}($Resource));
export { WebhookDeliveriesResource };
var WebhookSettingsResource = /** @class */ (function (_super) {
    __extends(WebhookSettingsResource, _super);
    function WebhookSettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns the webhook settings for an organization*/
    WebhookSettingsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/webhook/settings",
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Updates the webhook settings for an organization*/
    WebhookSettingsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/webhook/settings",
            headers: params.headers,
            method: 'PUT',
        });
    };
    return WebhookSettingsResource;
}($Resource));
export { WebhookSettingsResource };
var AddressesResource = /** @class */ (function (_super) {
    __extends(AddressesResource, _super);
    function AddressesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Geolocates the request based on the provided parameters, returning a list of potential matching addresses.*/
    AddressesResource.prototype.get = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/addresses',
            headers: params.headers,
            method: 'GET',
            query: {
                address: params.address,
                country: params.country,
                ip: params.ip,
                postal_prefix: params.postal_prefix,
            },
        });
    };
    AddressesResource.prototype.postVerifications = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/addresses/verifications',
            headers: params.headers,
            method: 'POST',
        });
    };
    return AddressesResource;
}($Resource));
export { AddressesResource };
var CountryDefaultsResource = /** @class */ (function (_super) {
    __extends(CountryDefaultsResource, _super);
    function CountryDefaultsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CountryDefaultsResource.prototype.get = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/geolocation/defaults',
            headers: params.headers,
            method: 'GET',
            query: {
                country: params.country,
                ip: params.ip,
            },
        });
    };
    CountryDefaultsResource.prototype.getByCountry = function (params) {
        return this.client.request({
            endpoint: "/geolocation/defaults/" + encodeURIComponent(params.country),
            headers: params.headers,
            method: 'GET',
        });
    };
    return CountryDefaultsResource;
}($Resource));
export { CountryDefaultsResource };
var TimezonesResource = /** @class */ (function (_super) {
    __extends(TimezonesResource, _super);
    function TimezonesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Provides timezone based on address or geolocated IP.*/
    TimezonesResource.prototype.getGeolocationAndTimezones = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/geolocation/timezones',
            headers: params.headers,
            method: 'GET',
            query: {
                ip: params.ip,
            },
        });
    };
    /*Returns a list of timezones.*/
    TimezonesResource.prototype.getReferenceAndTimezones = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/reference/timezones',
            headers: params.headers,
            method: 'GET',
            query: {
                q: params.q,
            },
        });
    };
    return TimezonesResource;
}($Resource));
export { TimezonesResource };
var CarriersResource = /** @class */ (function (_super) {
    __extends(CarriersResource, _super);
    function CarriersResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns a list of carriers supported by Flow.*/
    CarriersResource.prototype.get = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/reference/carriers',
            headers: params.headers,
            method: 'GET',
            query: {
                q: params.q,
            },
        });
    };
    return CarriersResource;
}($Resource));
export { CarriersResource };
var CarrierServicesResource = /** @class */ (function (_super) {
    __extends(CarrierServicesResource, _super);
    function CarrierServicesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns a list of carrier services supported by Flow.*/
    CarrierServicesResource.prototype.get = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/reference/carrier/services',
            headers: params.headers,
            method: 'GET',
            query: {
                q: params.q,
            },
        });
    };
    return CarrierServicesResource;
}($Resource));
export { CarrierServicesResource };
var CountriesResource = /** @class */ (function (_super) {
    __extends(CountriesResource, _super);
    function CountriesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns a list of countries.*/
    CountriesResource.prototype.get = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/reference/countries',
            headers: params.headers,
            method: 'GET',
            query: {
                q: params.q,
            },
        });
    };
    return CountriesResource;
}($Resource));
export { CountriesResource };
var CurrenciesResource = /** @class */ (function (_super) {
    __extends(CurrenciesResource, _super);
    function CurrenciesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns a list of currencies.*/
    CurrenciesResource.prototype.get = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/reference/currencies',
            headers: params.headers,
            method: 'GET',
            query: {
                q: params.q,
            },
        });
    };
    return CurrenciesResource;
}($Resource));
export { CurrenciesResource };
var LanguagesResource = /** @class */ (function (_super) {
    __extends(LanguagesResource, _super);
    function LanguagesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns a list of languages.*/
    LanguagesResource.prototype.get = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/reference/languages',
            headers: params.headers,
            method: 'GET',
            query: {
                q: params.q,
            },
        });
    };
    return LanguagesResource;
}($Resource));
export { LanguagesResource };
var LocalesResource = /** @class */ (function (_super) {
    __extends(LocalesResource, _super);
    function LocalesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns a list of locales.*/
    LocalesResource.prototype.get = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/reference/locales',
            headers: params.headers,
            method: 'GET',
            query: {
                q: params.q,
            },
        });
    };
    /*Returns the locale with the specifed id.*/
    LocalesResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/reference/locales/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    return LocalesResource;
}($Resource));
export { LocalesResource };
var PaymentMethodsResource = /** @class */ (function (_super) {
    __extends(PaymentMethodsResource, _super);
    function PaymentMethodsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns a list of payment methods supported by Flow.*/
    PaymentMethodsResource.prototype.get = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/reference/payment/methods',
            headers: params.headers,
            method: 'GET',
            query: {
                q: params.q,
            },
        });
    };
    return PaymentMethodsResource;
}($Resource));
export { PaymentMethodsResource };
var ProvincesResource = /** @class */ (function (_super) {
    __extends(ProvincesResource, _super);
    function ProvincesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns a list of provinces.*/
    ProvincesResource.prototype.get = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/reference/provinces',
            headers: params.headers,
            method: 'GET',
            query: {
                countries: params.countries,
                q: params.q,
            },
        });
    };
    /*Returns the province with the specifed id.*/
    ProvincesResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/reference/provinces/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    return ProvincesResource;
}($Resource));
export { ProvincesResource };
var RegionsResource = /** @class */ (function (_super) {
    __extends(RegionsResource, _super);
    function RegionsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns a list of regions.*/
    RegionsResource.prototype.get = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/reference/regions',
            headers: params.headers,
            method: 'GET',
            query: {
                q: params.q,
            },
        });
    };
    /*Returns the region with the specifed id.*/
    RegionsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/reference/regions/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    return RegionsResource;
}($Resource));
export { RegionsResource };
var AbandonedOrderSettingsResource = /** @class */ (function (_super) {
    __extends(AbandonedOrderSettingsResource, _super);
    function AbandonedOrderSettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AbandonedOrderSettingsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/marketing/abandoned/order/settings",
            headers: params.headers,
            method: 'GET',
        });
    };
    AbandonedOrderSettingsResource.prototype.post = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/marketing/abandoned/order/settings",
            headers: params.headers,
            method: 'POST',
            query: {
                delay_time: params.delay_time,
                delay_unit: params.delay_unit,
                frequency_time: params.frequency_time,
                frequency_unit: params.frequency_unit,
                status: params.status,
            },
        });
    };
    AbandonedOrderSettingsResource.prototype.put = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/marketing/abandoned/order/settings",
            headers: params.headers,
            method: 'PUT',
            query: {
                delay_time: params.delay_time,
                delay_unit: params.delay_unit,
                frequency_time: params.frequency_time,
                frequency_unit: params.frequency_unit,
                status: params.status,
            },
        });
    };
    AbandonedOrderSettingsResource.prototype.delete = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/marketing/abandoned/order/settings",
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return AbandonedOrderSettingsResource;
}($Resource));
export { AbandonedOrderSettingsResource };
var B2BCreditMemosResource = /** @class */ (function (_super) {
    __extends(B2BCreditMemosResource, _super);
    function B2BCreditMemosResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    B2BCreditMemosResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/b2b/credit/memos",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                order_number: params.order_number,
                sort: params.sort,
            },
        });
    };
    return B2BCreditMemosResource;
}($Resource));
export { B2BCreditMemosResource };
var B2BInvoicesResource = /** @class */ (function (_super) {
    __extends(B2BInvoicesResource, _super);
    function B2BInvoicesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    B2BInvoicesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/b2b/invoices",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                order_number: params.order_number,
                sort: params.sort,
            },
        });
    };
    /*Creates an export of the b2b invoices*/
    B2BInvoicesResource.prototype.postExports = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/b2b/invoices/exports",
            headers: params.headers,
            method: 'POST',
        });
    };
    B2BInvoicesResource.prototype.getByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/b2b/invoices/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'GET',
        });
    };
    return B2BInvoicesResource;
}($Resource));
export { B2BInvoicesResource };
var CatalogPriceBookItemDocumentsResource = /** @class */ (function (_super) {
    __extends(CatalogPriceBookItemDocumentsResource, _super);
    function CatalogPriceBookItemDocumentsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns price book item documents based on the search criteria*/
    CatalogPriceBookItemDocumentsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/search/price/books/items",
            headers: params.headers,
            method: 'GET',
            query: {
                limit: params.limit,
                offset: params.offset,
                price_book_key: params.price_book_key,
                q: params.q,
            },
        });
    };
    return CatalogPriceBookItemDocumentsResource;
}($Resource));
export { CatalogPriceBookItemDocumentsResource };
var CheckoutTokensResource = /** @class */ (function (_super) {
    __extends(CheckoutTokensResource, _super);
    function CheckoutTokensResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckoutTokensResource.prototype.getCheckoutAndTokensById = function (params) {
        return this.client.request({
            endpoint: "/checkout/tokens/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    CheckoutTokensResource.prototype.deleteCheckoutAndTokensById = function (params) {
        return this.client.request({
            endpoint: "/checkout/tokens/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    CheckoutTokensResource.prototype.postCheckoutAndTokensByOrganization = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/checkout/tokens",
            headers: params.headers,
            method: 'POST',
            query: {
                context: params.context,
            },
        });
    };
    return CheckoutTokensResource;
}($Resource));
export { CheckoutTokensResource };
var ConsumerInvoicesResource = /** @class */ (function (_super) {
    __extends(ConsumerInvoicesResource, _super);
    function ConsumerInvoicesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConsumerInvoicesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/consumer/invoices",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                order_number: params.order_number,
                sort: params.sort,
            },
        });
    };
    /*Creates an export of the consumer/invoices*/
    ConsumerInvoicesResource.prototype.postExports = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/consumer/invoices/exports",
            headers: params.headers,
            method: 'POST',
        });
    };
    ConsumerInvoicesResource.prototype.putOrderByNumber = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/consumer/invoices/order/" + encodeURIComponent(params.number),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Creates a credit memo against this invoice*/
    ConsumerInvoicesResource.prototype.postCreditAndMemosByInvoiceKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/consumer/invoices/" + encodeURIComponent(params.invoice_key) + "/credit/memos",
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Upserts a credit memo against this invoice*/
    ConsumerInvoicesResource.prototype.putCreditAndMemosByInvoiceKeyAndKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/consumer/invoices/" + encodeURIComponent(params.invoice_key) + "/credit/memos/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'PUT',
        });
    };
    ConsumerInvoicesResource.prototype.deleteCreditAndMemosByInvoiceKeyAndKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/consumer/invoices/" + encodeURIComponent(params.invoice_key) + "/credit/memos/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    ConsumerInvoicesResource.prototype.getByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/consumer/invoices/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'GET',
        });
    };
    ConsumerInvoicesResource.prototype.putByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/consumer/invoices/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'PUT',
        });
    };
    ConsumerInvoicesResource.prototype.deleteByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/consumer/invoices/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return ConsumerInvoicesResource;
}($Resource));
export { ConsumerInvoicesResource };
var ConsumerInvoiceDocumentsResource = /** @class */ (function (_super) {
    __extends(ConsumerInvoiceDocumentsResource, _super);
    function ConsumerInvoiceDocumentsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConsumerInvoiceDocumentsResource.prototype.getTokensAndTypeByTokenAndType = function (params) {
        return this.client.request({
            endpoint: "/consumer/invoice/document/tokens/" + encodeURIComponent(params.token) + "/type/" + encodeURIComponent(params.type),
            headers: params.headers,
            method: 'GET',
            query: {
                language: params.language,
            },
        });
    };
    return ConsumerInvoiceDocumentsResource;
}($Resource));
export { ConsumerInvoiceDocumentsResource };
var CountryPickersResource = /** @class */ (function (_super) {
    __extends(CountryPickersResource, _super);
    function CountryPickersResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CountryPickersResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/organizations/" + encodeURIComponent(params.organization_id) + "/country/picker",
            headers: params.headers,
            method: 'GET',
        });
    };
    CountryPickersResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/organizations/" + encodeURIComponent(params.organization_id) + "/country/picker",
            headers: params.headers,
            method: 'PUT',
        });
    };
    return CountryPickersResource;
}($Resource));
export { CountryPickersResource };
var CreditMemosResource = /** @class */ (function (_super) {
    __extends(CreditMemosResource, _super);
    function CreditMemosResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CreditMemosResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/credit/memos",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                order_number: params.order_number,
                sort: params.sort,
            },
        });
    };
    return CreditMemosResource;
}($Resource));
export { CreditMemosResource };
var CustomersResource = /** @class */ (function (_super) {
    __extends(CustomersResource, _super);
    function CustomersResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Search customers. Always paginated.*/
    CustomersResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/customers",
            headers: params.headers,
            method: 'GET',
            query: {
                email: params.email,
                id: params.id,
                limit: params.limit,
                number: params.number,
                offset: params.offset,
                phone: params.phone,
                sort: params.sort,
            },
        });
    };
    /*Create a customer.*/
    CustomersResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/customers",
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Returns information about a specific customer given a client token.*/
    CustomersResource.prototype.postClientAndTokens = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/customers/client/tokens",
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Returns information about a specific customer.*/
    CustomersResource.prototype.getByNumber = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/customers/" + encodeURIComponent(params.number),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Update or create a customer with the specified number.*/
    CustomersResource.prototype.putByNumber = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/customers/" + encodeURIComponent(params.number),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Delete the customer with this number.*/
    CustomersResource.prototype.deleteByNumber = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/customers/" + encodeURIComponent(params.number),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return CustomersResource;
}($Resource));
export { CustomersResource };
var CustomerAddressBookResource = /** @class */ (function (_super) {
    __extends(CustomerAddressBookResource, _super);
    function CustomerAddressBookResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Retrieve customer addrress book.*/
    CustomerAddressBookResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/customers/" + encodeURIComponent(params.number) + "/addresses/book",
            headers: params.headers,
            method: 'GET',
        });
    };
    return CustomerAddressBookResource;
}($Resource));
export { CustomerAddressBookResource };
var CustomerAddressBookContactsResource = /** @class */ (function (_super) {
    __extends(CustomerAddressBookContactsResource, _super);
    function CustomerAddressBookContactsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Search contacts. Always paginated.*/
    CustomerAddressBookContactsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/customers/" + encodeURIComponent(params.number) + "/addresses/book/contacts",
            headers: params.headers,
            method: 'GET',
            query: {
                email: params.email,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                phone: params.phone,
                sort: params.sort,
            },
        });
    };
    /*Create a contact.*/
    CustomerAddressBookContactsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/customers/" + encodeURIComponent(params.number) + "/addresses/book/contacts",
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Returns information about a specific contact.*/
    CustomerAddressBookContactsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/customers/" + encodeURIComponent(params.number) + "/addresses/book/contacts/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Update or create a contact with the specified id.*/
    CustomerAddressBookContactsResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/customers/" + encodeURIComponent(params.number) + "/addresses/book/contacts/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Delete the contact with this id.*/
    CustomerAddressBookContactsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/customers/" + encodeURIComponent(params.number) + "/addresses/book/contacts/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return CustomerAddressBookContactsResource;
}($Resource));
export { CustomerAddressBookContactsResource };
var CustomerBundlesResource = /** @class */ (function (_super) {
    __extends(CustomerBundlesResource, _super);
    function CustomerBundlesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns information about a specific customer.*/
    CustomerBundlesResource.prototype.getBundleByNumber = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/customers/" + encodeURIComponent(params.number) + "/bundle",
            headers: params.headers,
            method: 'GET',
        });
    };
    return CustomerBundlesResource;
}($Resource));
export { CustomerBundlesResource };
var CustomerPurgeSettingsResource = /** @class */ (function (_super) {
    __extends(CustomerPurgeSettingsResource, _super);
    function CustomerPurgeSettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomerPurgeSettingsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/customer/purge/settings",
            headers: params.headers,
            method: 'GET',
        });
    };
    CustomerPurgeSettingsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/customer/purge/settings",
            headers: params.headers,
            method: 'PUT',
        });
    };
    CustomerPurgeSettingsResource.prototype.delete = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/customer/purge/settings",
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return CustomerPurgeSettingsResource;
}($Resource));
export { CustomerPurgeSettingsResource };
var CustomerTokensResource = /** @class */ (function (_super) {
    __extends(CustomerTokensResource, _super);
    function CustomerTokensResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Search tokens.*/
    CustomerTokensResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/customer/tokens",
            headers: params.headers,
            method: 'GET',
            query: {
                customer_number: params.customer_number,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
                token: params.token,
            },
        });
    };
    /*If there exists at least one token for this customer number, returns the latest. Otherwise creates a new token and returns that*/
    CustomerTokensResource.prototype.postLatestByCustomerNumber = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/customer/tokens/latest/" + encodeURIComponent(params.customer_number),
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Delete the token for this id.*/
    CustomerTokensResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/customer/tokens/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    /*Returns a token if it exists.*/
    CustomerTokensResource.prototype.getByToken = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/customer/tokens/" + encodeURIComponent(params.token),
            headers: params.headers,
            method: 'GET',
        });
    };
    return CustomerTokensResource;
}($Resource));
export { CustomerTokensResource };
var DocumentsResource = /** @class */ (function (_super) {
    __extends(DocumentsResource, _super);
    function DocumentsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns items based on search criteria*/
    DocumentsResource.prototype.getCatalog = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/search/catalog",
            headers: params.headers,
            method: 'GET',
            query: {
                limit: params.limit,
                offset: params.offset,
                q: params.q,
                sort: params.sort,
            },
        });
    };
    /*Returns harmonization information based on search criteria*/
    DocumentsResource.prototype.getHarmonization = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/search/harmonization",
            headers: params.headers,
            method: 'GET',
            query: {
                limit: params.limit,
                offset: params.offset,
                q: params.q,
                sort: params.sort,
            },
        });
    };
    return DocumentsResource;
}($Resource));
export { DocumentsResource };
var EcommercePlatformsResource = /** @class */ (function (_super) {
    __extends(EcommercePlatformsResource, _super);
    function EcommercePlatformsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EcommercePlatformsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/organizations/" + encodeURIComponent(params.organization_id) + "/ecommerce/platform",
            headers: params.headers,
            method: 'GET',
        });
    };
    EcommercePlatformsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/organizations/" + encodeURIComponent(params.organization_id) + "/ecommerce/platform",
            headers: params.headers,
            method: 'PUT',
        });
    };
    return EcommercePlatformsResource;
}($Resource));
export { EcommercePlatformsResource };
var EmailVerificationsResource = /** @class */ (function (_super) {
    __extends(EmailVerificationsResource, _super);
    function EmailVerificationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmailVerificationsResource.prototype.postByToken = function (params) {
        return this.client.request({
            endpoint: "/users/emails/verifications/" + encodeURIComponent(params.token),
            headers: params.headers,
            method: 'POST',
        });
    };
    return EmailVerificationsResource;
}($Resource));
export { EmailVerificationsResource };
var ExclusionRulesResource = /** @class */ (function (_super) {
    __extends(ExclusionRulesResource, _super);
    function ExclusionRulesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns a list of exclusions rules.*/
    ExclusionRulesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/exclusion/rules",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    ExclusionRulesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/exclusion/rules",
            headers: params.headers,
            method: 'POST',
        });
    };
    ExclusionRulesResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/exclusion/rules/versions",
            headers: params.headers,
            method: 'GET',
            query: {
                exclusion_rule_id: params.exclusion_rule_id,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Updates the specified exclusion rule.*/
    ExclusionRulesResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/exclusion/rules/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Marks the exclusion rule deleted. Once updated, the rule itself will be deleted.*/
    ExclusionRulesResource.prototype.putDeletionById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/exclusion/rules/" + encodeURIComponent(params.id) + "/deletion",
            headers: params.headers,
            method: 'PUT',
        });
    };
    return ExclusionRulesResource;
}($Resource));
export { ExclusionRulesResource };
var ExportsResource = /** @class */ (function (_super) {
    __extends(ExportsResource, _super);
    function ExportsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Search exports. Always paginated.*/
    ExportsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/exports",
            headers: params.headers,
            method: 'GET',
            query: {
                created_by_user_id: params.created_by_user_id,
                discriminator: params.discriminator,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Create an export.*/
    ExportsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/exports",
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Provides visibility into recent changes of each export, including deletion.*/
    ExportsResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/exports/versions",
            headers: params.headers,
            method: 'GET',
            query: {
                export_id: params.export_id,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Get a single export.*/
    ExportsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/exports/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    ExportsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/exports/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return ExportsResource;
}($Resource));
export { ExportsResource };
var FlowRolesResource = /** @class */ (function (_super) {
    __extends(FlowRolesResource, _super);
    function FlowRolesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*List roles in use by this organization.*/
    FlowRolesResource.prototype.getOrganizationAndRolesByOrganization = function (params) {
        return this.client.request({
            endpoint: "/permission/organization/" + encodeURIComponent(params.organization) + "/roles",
            headers: params.headers,
            method: 'GET',
        });
    };
    return FlowRolesResource;
}($Resource));
export { FlowRolesResource };
var FraudEmailRulesResource = /** @class */ (function (_super) {
    __extends(FraudEmailRulesResource, _super);
    function FraudEmailRulesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Retrieve fraud review email rules. Always paginated.*/
    FraudEmailRulesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/fraud/email/rules",
            headers: params.headers,
            method: 'GET',
            query: {
                decision: params.decision,
                email: params.email,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Add an email decision rule.*/
    FraudEmailRulesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/fraud/email/rules",
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Remove an email decision rule.*/
    FraudEmailRulesResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/fraud/email/rules/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return FraudEmailRulesResource;
}($Resource));
export { FraudEmailRulesResource };
var FtpFilesResource = /** @class */ (function (_super) {
    __extends(FtpFilesResource, _super);
    function FtpFilesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FtpFilesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/ftp/files",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                name: params.name,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    FtpFilesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/ftp/files",
            headers: params.headers,
            method: 'POST',
        });
    };
    FtpFilesResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/ftp/files/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    FtpFilesResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/ftp/files/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return FtpFilesResource;
}($Resource));
export { FtpFilesResource };
var FtpFoldersResource = /** @class */ (function (_super) {
    __extends(FtpFoldersResource, _super);
    function FtpFoldersResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FtpFoldersResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/ftp/folders",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                path: params.path,
                sort: params.sort,
            },
        });
    };
    FtpFoldersResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/ftp/folders",
            headers: params.headers,
            method: 'POST',
        });
    };
    FtpFoldersResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/ftp/folders/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    FtpFoldersResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/ftp/folders/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return FtpFoldersResource;
}($Resource));
export { FtpFoldersResource };
var FtpOrganizationSettingsResource = /** @class */ (function (_super) {
    __extends(FtpOrganizationSettingsResource, _super);
    function FtpOrganizationSettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FtpOrganizationSettingsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/ftp/settings",
            headers: params.headers,
            method: 'GET',
        });
    };
    FtpOrganizationSettingsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/ftp/settings",
            headers: params.headers,
            method: 'PUT',
        });
    };
    FtpOrganizationSettingsResource.prototype.delete = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/ftp/settings",
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return FtpOrganizationSettingsResource;
}($Resource));
export { FtpOrganizationSettingsResource };
var FulfillmentsResource = /** @class */ (function (_super) {
    __extends(FulfillmentsResource, _super);
    function FulfillmentsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FulfillmentsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/orders/" + encodeURIComponent(params.number) + "/fulfillments",
            headers: params.headers,
            method: 'GET',
        });
    };
    FulfillmentsResource.prototype.putCancellations = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/orders/" + encodeURIComponent(params.number) + "/fulfillments/cancellations",
            headers: params.headers,
            method: 'PUT',
        });
    };
    FulfillmentsResource.prototype.putCompleteAndCancellations = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/orders/" + encodeURIComponent(params.number) + "/fulfillments/complete/cancellations",
            headers: params.headers,
            method: 'PUT',
        });
    };
    return FulfillmentsResource;
}($Resource));
export { FulfillmentsResource };
var HealthchecksResource = /** @class */ (function (_super) {
    __extends(HealthchecksResource, _super);
    function HealthchecksResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HealthchecksResource.prototype.getHealthcheck = function (params) {
        if (params === void 0) { params = {}; }
        return this.client.request({
            endpoint: '/_internal_/healthcheck',
            headers: params.headers,
            method: 'GET',
        });
    };
    return HealthchecksResource;
}($Resource));
export { HealthchecksResource };
var ImportsResource = /** @class */ (function (_super) {
    __extends(ImportsResource, _super);
    function ImportsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Search imports. Always paginated.*/
    ImportsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/imports",
            headers: params.headers,
            method: 'GET',
            query: {
                created_by_user_id: params.created_by_user_id,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
                type: params.type,
            },
        });
    };
    /*Create an import.*/
    ImportsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/imports",
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Provides visibility into recent changes of each import, including deletion.*/
    ImportsResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/imports/versions",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                import_id: params.import_id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Get a single import.*/
    ImportsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/imports/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    ImportsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/imports/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return ImportsResource;
}($Resource));
export { ImportsResource };
var ImportTemplatesResource = /** @class */ (function (_super) {
    __extends(ImportTemplatesResource, _super);
    function ImportTemplatesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ImportTemplatesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/import/templates",
            headers: params.headers,
            method: 'GET',
        });
    };
    ImportTemplatesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/import/templates",
            headers: params.headers,
            method: 'POST',
        });
    };
    return ImportTemplatesResource;
}($Resource));
export { ImportTemplatesResource };
var InvitationsResource = /** @class */ (function (_super) {
    __extends(InvitationsResource, _super);
    function InvitationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Search invitations. Always paginated.*/
    InvitationsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/invitations',
            headers: params.headers,
            method: 'GET',
            query: {
                email: params.email,
                expand: params.expand,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                organization: params.organization,
                sort: params.sort,
                token: params.token,
            },
        });
    };
    /*Create a new invitation.*/
    InvitationsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/invitations',
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Lookup an invitation by its token.*/
    InvitationsResource.prototype.getTokensByToken = function (params) {
        return this.client.request({
            endpoint: "/invitations/tokens/" + encodeURIComponent(params.token),
            headers: params.headers,
            method: 'GET',
            query: {
                expand: params.expand,
            },
        });
    };
    /*Accepts the invitation w/ the specified token and the authenticated user. Creating a membership record for this user within this organization. Invitations are one time use only - you will get a validation error if the invitation has previously been accepted or if the user's email addresses do not match the email on the invite.*/
    InvitationsResource.prototype.putTokensByToken = function (params) {
        return this.client.request({
            endpoint: "/invitations/tokens/" + encodeURIComponent(params.token),
            headers: params.headers,
            method: 'PUT',
        });
    };
    InvitationsResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: '/invitations/versions',
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                invitation: params.invitation,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Returns information about a specific invitation.*/
    InvitationsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/invitations/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
            query: {
                expand: params.expand,
            },
        });
    };
    InvitationsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/invitations/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return InvitationsResource;
}($Resource));
export { InvitationsResource };
var PriceRulesResource = /** @class */ (function (_super) {
    __extends(PriceRulesResource, _super);
    function PriceRulesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PriceRulesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/shopify/price/rules/discount/" + encodeURIComponent(params.code),
            headers: params.headers,
            method: 'GET',
        });
    };
    return PriceRulesResource;
}($Resource));
export { PriceRulesResource };
var ItemQuerySuggestionsResource = /** @class */ (function (_super) {
    __extends(ItemQuerySuggestionsResource, _super);
    function ItemQuerySuggestionsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns search suggestions for catalog items*/
    ItemQuerySuggestionsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/search/item/query/suggestions",
            headers: params.headers,
            method: 'GET',
            query: {
                limit: params.limit,
                offset: params.offset,
                q: params.q,
            },
        });
    };
    return ItemQuerySuggestionsResource;
}($Resource));
export { ItemQuerySuggestionsResource };
var LinksResource = /** @class */ (function (_super) {
    __extends(LinksResource, _super);
    function LinksResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LinksResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/carrier/" + encodeURIComponent(params.carrier) + "/data/" + encodeURIComponent(params.organization) + "/" + encodeURIComponent(params.order_number),
            headers: params.headers,
            method: 'GET',
        });
    };
    return LinksResource;
}($Resource));
export { LinksResource };
var MembershipsResource = /** @class */ (function (_super) {
    __extends(MembershipsResource, _super);
    function MembershipsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Search memberships. Always paginated.*/
    MembershipsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/memberships',
            headers: params.headers,
            method: 'GET',
            query: {
                expand: params.expand,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                organization: params.organization,
                role: params.role,
                sort: params.sort,
                user: params.user,
            },
        });
    };
    /*Create a new membership.*/
    MembershipsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/memberships',
            headers: params.headers,
            method: 'POST',
        });
    };
    MembershipsResource.prototype.getVersions = function (params) {
        return this.client.request({
            endpoint: '/memberships/versions',
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                membership: params.membership,
                offset: params.offset,
                organization: params.organization,
                sort: params.sort,
                user: params.user,
            },
        });
    };
    /*Returns information about a specific membership.*/
    MembershipsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/memberships/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
            query: {
                expand: params.expand,
            },
        });
    };
    /*Change the role for a specific membership record. If the user already has the specified role within the organization, does nothing.*/
    MembershipsResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/memberships/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'PUT',
        });
    };
    MembershipsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/memberships/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return MembershipsResource;
}($Resource));
export { MembershipsResource };
var MerchantGiftCardBalancesResource = /** @class */ (function (_super) {
    __extends(MerchantGiftCardBalancesResource, _super);
    function MerchantGiftCardBalancesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Check the remaining balance on a gift card*/
    MerchantGiftCardBalancesResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/balance',
            headers: params.headers,
            method: 'POST',
        });
    };
    return MerchantGiftCardBalancesResource;
}($Resource));
export { MerchantGiftCardBalancesResource };
var MerchantGiftCardRedemptionsResource = /** @class */ (function (_super) {
    __extends(MerchantGiftCardRedemptionsResource, _super);
    function MerchantGiftCardRedemptionsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Redeems a gift card*/
    MerchantGiftCardRedemptionsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/redeem',
            headers: params.headers,
            method: 'POST',
        });
    };
    return MerchantGiftCardRedemptionsResource;
}($Resource));
export { MerchantGiftCardRedemptionsResource };
var MerchantGiftCardReversalsResource = /** @class */ (function (_super) {
    __extends(MerchantGiftCardReversalsResource, _super);
    function MerchantGiftCardReversalsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Check the remaining balance on a gift card*/
    MerchantGiftCardReversalsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/reverse',
            headers: params.headers,
            method: 'POST',
        });
    };
    return MerchantGiftCardReversalsResource;
}($Resource));
export { MerchantGiftCardReversalsResource };
var OrganizationAuthorizationsResource = /** @class */ (function (_super) {
    __extends(OrganizationAuthorizationsResource, _super);
    function OrganizationAuthorizationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*For the authorized user, if the specified organization exists, and the user is an active member of this organization, returns the authorization data used throughout APIs at Flow, including the user's role in that organization and the organization environment. Otherwise, returns 401 - this indicates either the org does not exist or the user does not have access to the org.*/
    OrganizationAuthorizationsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/organization-authorizations',
            headers: params.headers,
            method: 'POST',
        });
    };
    /*For the authorized user and specific organization, if the user is an active member of this organization, returns the authorization data used throughout APIs at Flow, including the user's role in that organization and the organization environment.*/
    OrganizationAuthorizationsResource.prototype.getByOrganization = function (params) {
        return this.client.request({
            endpoint: "/organization-authorizations/" + encodeURIComponent(params.organization),
            headers: params.headers,
            method: 'GET',
        });
    };
    return OrganizationAuthorizationsResource;
}($Resource));
export { OrganizationAuthorizationsResource };
var OrganizationDefaultConfigurationsResource = /** @class */ (function (_super) {
    __extends(OrganizationDefaultConfigurationsResource, _super);
    function OrganizationDefaultConfigurationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrganizationDefaultConfigurationsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization_id) + "/default/configurations",
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Update the default checkout configuration id for this organization*/
    OrganizationDefaultConfigurationsResource.prototype.putCheckout = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization_id) + "/default/configurations/checkout",
            headers: params.headers,
            method: 'PUT',
        });
    };
    return OrganizationDefaultConfigurationsResource;
}($Resource));
export { OrganizationDefaultConfigurationsResource };
var OrganizationTokensResource = /** @class */ (function (_super) {
    __extends(OrganizationTokensResource, _super);
    function OrganizationTokensResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Get all tokens for the specified organization*/
    OrganizationTokensResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/tokens",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                mine: params.mine,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Create a new organization*/
    OrganizationTokensResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/tokens",
            headers: params.headers,
            method: 'POST',
        });
    };
    return OrganizationTokensResource;
}($Resource));
export { OrganizationTokensResource };
var PartnerTokensResource = /** @class */ (function (_super) {
    __extends(PartnerTokensResource, _super);
    function PartnerTokensResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Get all tokens for the specified partner*/
    PartnerTokensResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/partners/" + encodeURIComponent(params.partner) + "/tokens",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                mine: params.mine,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Create a new partner*/
    PartnerTokensResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/partners/" + encodeURIComponent(params.partner) + "/tokens",
            headers: params.headers,
            method: 'POST',
        });
    };
    return PartnerTokensResource;
}($Resource));
export { PartnerTokensResource };
var PasswordResetFormsResource = /** @class */ (function (_super) {
    __extends(PasswordResetFormsResource, _super);
    function PasswordResetFormsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PasswordResetFormsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/users/passwords',
            headers: params.headers,
            method: 'POST',
            query: {
                expand: params.expand,
            },
        });
    };
    PasswordResetFormsResource.prototype.postResets = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/users/passwords/resets',
            headers: params.headers,
            method: 'POST',
        });
    };
    return PasswordResetFormsResource;
}($Resource));
export { PasswordResetFormsResource };
var PermissionChecksResource = /** @class */ (function (_super) {
    __extends(PermissionChecksResource, _super);
    function PermissionChecksResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns permissions for the specified organization for the current request. Used by integrators to test headers.*/
    PermissionChecksResource.prototype.getPermissionAndChecksAndAllByOrganization = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/permission/checks/all",
            headers: params.headers,
            method: 'GET',
            query: {
                path: params.path,
                permitted_method: params.permitted_method,
            },
        });
    };
    return PermissionChecksResource;
}($Resource));
export { PermissionChecksResource };
var PriceBookItemExportOptionsResource = /** @class */ (function (_super) {
    __extends(PriceBookItemExportOptionsResource, _super);
    function PriceBookItemExportOptionsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PriceBookItemExportOptionsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/export/options/price_book_item",
            headers: params.headers,
            method: 'GET',
        });
    };
    return PriceBookItemExportOptionsResource;
}($Resource));
export { PriceBookItemExportOptionsResource };
var ScheduledExportsResource = /** @class */ (function (_super) {
    __extends(ScheduledExportsResource, _super);
    function ScheduledExportsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Search scheduled exports. Always paginated.*/
    ScheduledExportsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/users/scheduled/exports',
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Create a scheduled export.*/
    ScheduledExportsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/users/scheduled/exports',
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Get a single scheduled export.*/
    ScheduledExportsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/users/scheduled/exports/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Update a scheduled export.*/
    ScheduledExportsResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/users/scheduled/exports/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'PUT',
        });
    };
    ScheduledExportsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/users/scheduled/exports/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return ScheduledExportsResource;
}($Resource));
export { ScheduledExportsResource };
var SessionsResource = /** @class */ (function (_super) {
    __extends(SessionsResource, _super);
    function SessionsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SessionsResource.prototype.postShopifyAndOrganizationsByOrganization = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/sessions/shopify/organizations/" + encodeURIComponent(params.organization),
            headers: params.headers,
            method: 'POST',
        });
    };
    SessionsResource.prototype.getShopifyBySession = function (params) {
        return this.client.request({
            endpoint: "/sessions/shopify/" + encodeURIComponent(params.session),
            headers: params.headers,
            method: 'GET',
        });
    };
    SessionsResource.prototype.putShopifyBySession = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/sessions/shopify/" + encodeURIComponent(params.session),
            headers: params.headers,
            method: 'PUT',
        });
    };
    SessionsResource.prototype.deleteShopifyBySession = function (params) {
        return this.client.request({
            endpoint: "/sessions/shopify/" + encodeURIComponent(params.session),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    /*Clears the session geo parameters*/
    SessionsResource.prototype.putShopifyAndClearBySession = function (params) {
        return this.client.request({
            endpoint: "/sessions/shopify/" + encodeURIComponent(params.session) + "/clear",
            headers: params.headers,
            method: 'PUT',
        });
    };
    SessionsResource.prototype.putShopifyAndOrganizationsBySessionAndOrganization = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/sessions/shopify/" + encodeURIComponent(params.session) + "/organizations/" + encodeURIComponent(params.organization),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Resets the session based on the provided geo parameters.*/
    SessionsResource.prototype.putShopifyAndResetBySession = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/sessions/shopify/" + encodeURIComponent(params.session) + "/reset",
            headers: params.headers,
            method: 'PUT',
        });
    };
    SessionsResource.prototype.postOrganizationsByOrganization = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/sessions/organizations/" + encodeURIComponent(params.organization),
            headers: params.headers,
            method: 'POST',
            query: {
                context: params.context,
            },
        });
    };
    SessionsResource.prototype.getBySession = function (params) {
        return this.client.request({
            endpoint: "/sessions/" + encodeURIComponent(params.session),
            headers: params.headers,
            method: 'GET',
        });
    };
    SessionsResource.prototype.putBySession = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/sessions/" + encodeURIComponent(params.session),
            headers: params.headers,
            method: 'PUT',
            query: {
                context: params.context,
            },
        });
    };
    SessionsResource.prototype.deleteBySession = function (params) {
        return this.client.request({
            endpoint: "/sessions/" + encodeURIComponent(params.session),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    /*Clears the session geo parameters*/
    SessionsResource.prototype.putClearBySession = function (params) {
        return this.client.request({
            endpoint: "/sessions/" + encodeURIComponent(params.session) + "/clear",
            headers: params.headers,
            method: 'PUT',
        });
    };
    SessionsResource.prototype.putOrganizationsBySessionAndOrganization = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/sessions/" + encodeURIComponent(params.session) + "/organizations/" + encodeURIComponent(params.organization),
            headers: params.headers,
            method: 'PUT',
            query: {
                context: params.context,
            },
        });
    };
    /*Resets the session based on the provided geo parameters.*/
    SessionsResource.prototype.putResetBySession = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/sessions/" + encodeURIComponent(params.session) + "/reset",
            headers: params.headers,
            method: 'PUT',
            query: {
                context: params.context,
            },
        });
    };
    return SessionsResource;
}($Resource));
export { SessionsResource };
var SessionAuthorizationsResource = /** @class */ (function (_super) {
    __extends(SessionAuthorizationsResource, _super);
    function SessionAuthorizationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SessionAuthorizationsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/authorizations/sessions',
            headers: params.headers,
            method: 'POST',
        });
    };
    return SessionAuthorizationsResource;
}($Resource));
export { SessionAuthorizationsResource };
var ShopifyCartsResource = /** @class */ (function (_super) {
    __extends(ShopifyCartsResource, _super);
    function ShopifyCartsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Retrieve representation of a Shopify cart for the given order number.*/
    ShopifyCartsResource.prototype.getOrderByNumber = function (params) {
        return this.client.request({
            endpoint: "/shopify/carts/order/" + encodeURIComponent(params.number),
            headers: params.headers,
            method: 'GET',
            query: {
                context: params.context,
            },
        });
    };
    /*Retrieve representation of a Shopify cart given the unique cart id.*/
    ShopifyCartsResource.prototype.getByIdHtml = function (params) {
        return this.client.request({
            endpoint: "/shopify/carts/" + encodeURIComponent(params.id) + ".html",
            headers: params.headers,
            method: 'GET',
            query: {
                context: params.context,
            },
        });
    };
    /*Retrieve representation of a Shopify cart given the unique cart id.*/
    ShopifyCartsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/shopify/carts/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
            query: {
                context: params.context,
            },
        });
    };
    /*Add an item to a Shopify cart given the unique cart id.*/
    ShopifyCartsResource.prototype.postAddById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/shopify/carts/" + encodeURIComponent(params.id) + "/add",
            headers: params.headers,
            method: 'POST',
            query: {
                context: params.context,
            },
        });
    };
    /*Update the attribute information for the cart.*/
    ShopifyCartsResource.prototype.putAttributesById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/shopify/carts/" + encodeURIComponent(params.id) + "/attributes",
            headers: params.headers,
            method: 'PUT',
            query: {
                context: params.context,
            },
        });
    };
    /*Change/Update an item in a Shopify cart given the unique cart id.*/
    ShopifyCartsResource.prototype.postChangeById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/shopify/carts/" + encodeURIComponent(params.id) + "/change",
            headers: params.headers,
            method: 'POST',
            query: {
                context: params.context,
            },
        });
    };
    /*Remove all cart items given the unique cart id .*/
    ShopifyCartsResource.prototype.postClearById = function (params) {
        return this.client.request({
            endpoint: "/shopify/carts/" + encodeURIComponent(params.id) + "/clear",
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Update the geo information for the cart.*/
    ShopifyCartsResource.prototype.putGeoById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/shopify/carts/" + encodeURIComponent(params.id) + "/geo",
            headers: params.headers,
            method: 'PUT',
            query: {
                context: params.context,
            },
        });
    };
    /*Create an order from a Flow cart.*/
    ShopifyCartsResource.prototype.postOrdersById = function (params) {
        return this.client.request({
            endpoint: "/shopify/carts/" + encodeURIComponent(params.id) + "/orders",
            headers: params.headers,
            method: 'POST',
            query: {
                context: params.context,
                expand: params.expand,
            },
        });
    };
    return ShopifyCartsResource;
}($Resource));
export { ShopifyCartsResource };
var ShopifyCartConversionsResource = /** @class */ (function (_super) {
    __extends(ShopifyCartConversionsResource, _super);
    function ShopifyCartConversionsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Creates a shopify cart conversion from a shopify cart*/
    ShopifyCartConversionsResource.prototype.postConversions = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/experiences/" + encodeURIComponent(params.experience_key) + "/shopify/cart/conversions",
            headers: params.headers,
            method: 'POST',
            query: {
                context: params.context,
                expand: params.expand,
            },
        });
    };
    return ShopifyCartConversionsResource;
}($Resource));
export { ShopifyCartConversionsResource };
var ShopifyLocalizationSettingsResource = /** @class */ (function (_super) {
    __extends(ShopifyLocalizationSettingsResource, _super);
    function ShopifyLocalizationSettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShopifyLocalizationSettingsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/shopify/localization/settings",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Add a localization setting.*/
    ShopifyLocalizationSettingsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/shopify/localization/settings",
            headers: params.headers,
            method: 'POST',
        });
    };
    ShopifyLocalizationSettingsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/shopify/localization/settings/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Update a localization setting.*/
    ShopifyLocalizationSettingsResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/shopify/localization/settings/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'PUT',
        });
    };
    ShopifyLocalizationSettingsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/shopify/localization/settings/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return ShopifyLocalizationSettingsResource;
}($Resource));
export { ShopifyLocalizationSettingsResource };
var ShopifyLocationFlowCenterMappingsResource = /** @class */ (function (_super) {
    __extends(ShopifyLocationFlowCenterMappingsResource, _super);
    function ShopifyLocationFlowCenterMappingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShopifyLocationFlowCenterMappingsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/shopify/locations/mappings",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    /*Add a Shopify location/Flow Center mapping.*/
    ShopifyLocationFlowCenterMappingsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/shopify/locations/mappings",
            headers: params.headers,
            method: 'POST',
        });
    };
    ShopifyLocationFlowCenterMappingsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/shopify/locations/mappings/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Update a Shopify location/Flow Center mapping.*/
    ShopifyLocationFlowCenterMappingsResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/shopify/locations/mappings/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'PUT',
        });
    };
    ShopifyLocationFlowCenterMappingsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/shopify/locations/mappings/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return ShopifyLocationFlowCenterMappingsResource;
}($Resource));
export { ShopifyLocationFlowCenterMappingsResource };
var ShopifyPrivateAppsResource = /** @class */ (function (_super) {
    __extends(ShopifyPrivateAppsResource, _super);
    function ShopifyPrivateAppsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShopifyPrivateAppsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/shopify/private/apps",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
            },
        });
    };
    ShopifyPrivateAppsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/shopify/private/apps",
            headers: params.headers,
            method: 'PUT',
        });
    };
    ShopifyPrivateAppsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/shopify/private/apps/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    ShopifyPrivateAppsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/shopify/private/apps/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return ShopifyPrivateAppsResource;
}($Resource));
export { ShopifyPrivateAppsResource };
var ShopifySyncStatusesResource = /** @class */ (function (_super) {
    __extends(ShopifySyncStatusesResource, _super);
    function ShopifySyncStatusesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShopifySyncStatusesResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/shopify/sync/status",
            headers: params.headers,
            method: 'GET',
            query: {
                interval_seconds: params.interval_seconds,
                sync_check: params.sync_check,
            },
        });
    };
    return ShopifySyncStatusesResource;
}($Resource));
export { ShopifySyncStatusesResource };
var SuggestionsResource = /** @class */ (function (_super) {
    __extends(SuggestionsResource, _super);
    function SuggestionsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns search suggestions for catalog items*/
    SuggestionsResource.prototype.getCatalog = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/suggestion/catalog",
            headers: params.headers,
            method: 'GET',
            query: {
                limit: params.limit,
                offset: params.offset,
                q: params.q,
                sort: params.sort,
            },
        });
    };
    return SuggestionsResource;
}($Resource));
export { SuggestionsResource };
var SyncPendingRecordsResource = /** @class */ (function (_super) {
    __extends(SyncPendingRecordsResource, _super);
    function SyncPendingRecordsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SyncPendingRecordsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/sync/pending/records",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
                stream_key: params.stream_key,
                system: params.system,
                value: params.value,
            },
        });
    };
    return SyncPendingRecordsResource;
}($Resource));
export { SyncPendingRecordsResource };
var SyncRecordsResource = /** @class */ (function (_super) {
    __extends(SyncRecordsResource, _super);
    function SyncRecordsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SyncRecordsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/sync/records",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
                stream_key: params.stream_key,
                system: params.system,
                value: params.value,
            },
        });
    };
    SyncRecordsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/sync/records",
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Idempotent method to upsert a value for a system for this stream.*/
    SyncRecordsResource.prototype.putStreamsAndSystemsAndValuesByStreamKeyAndSystemAndValue = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/sync/records/streams/" + encodeURIComponent(params.stream_key) + "/systems/" + encodeURIComponent(params.system) + "/values/" + encodeURIComponent(params.value),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Delete a value for a system for this stream.*/
    SyncRecordsResource.prototype.deleteStreamsAndSystemsAndValuesByStreamKeyAndSystemAndValue = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/sync/records/streams/" + encodeURIComponent(params.stream_key) + "/systems/" + encodeURIComponent(params.system) + "/values/" + encodeURIComponent(params.value),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    SyncRecordsResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/sync/records/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    SyncRecordsResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/sync/records/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'PUT',
        });
    };
    SyncRecordsResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/sync/records/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return SyncRecordsResource;
}($Resource));
export { SyncRecordsResource };
var SyncRecordFailuresResource = /** @class */ (function (_super) {
    __extends(SyncRecordFailuresResource, _super);
    function SyncRecordFailuresResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SyncRecordFailuresResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/sync/record/failures",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                reason: params.reason,
                sort: params.sort,
                stream_key: params.stream_key,
                system: params.system,
                value: params.value,
            },
        });
    };
    SyncRecordFailuresResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/sync/record/failures",
            headers: params.headers,
            method: 'POST',
        });
    };
    SyncRecordFailuresResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/sync/record/failures/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    SyncRecordFailuresResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/sync/record/failures/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'PUT',
        });
    };
    SyncRecordFailuresResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/sync/record/failures/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return SyncRecordFailuresResource;
}($Resource));
export { SyncRecordFailuresResource };
var SyncStreamsResource = /** @class */ (function (_super) {
    __extends(SyncStreamsResource, _super);
    function SyncStreamsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SyncStreamsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/sync/streams",
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                key: params.key,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
                type: params.type,
            },
        });
    };
    SyncStreamsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/sync/streams",
            headers: params.headers,
            method: 'POST',
        });
    };
    SyncStreamsResource.prototype.getByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/sync/streams/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'GET',
        });
    };
    SyncStreamsResource.prototype.putByKey = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/sync/streams/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'PUT',
        });
    };
    SyncStreamsResource.prototype.deleteByKey = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/sync/streams/" + encodeURIComponent(params.key),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return SyncStreamsResource;
}($Resource));
export { SyncStreamsResource };
var TaxSettingsResource = /** @class */ (function (_super) {
    __extends(TaxSettingsResource, _super);
    function TaxSettingsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Returns the tax settings for the organization.*/
    TaxSettingsResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/tax/settings",
            headers: params.headers,
            method: 'GET',
        });
    };
    TaxSettingsResource.prototype.put = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/" + encodeURIComponent(params.organization) + "/tax/settings",
            headers: params.headers,
            method: 'PUT',
        });
    };
    TaxSettingsResource.prototype.delete = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/tax/settings",
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return TaxSettingsResource;
}($Resource));
export { TaxSettingsResource };
var TokensResource = /** @class */ (function (_super) {
    __extends(TokensResource, _super);
    function TokensResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Get all tokens that you are authorized to view. Note that the cleartext token value is never sent. To view the API token itself, see the resource path /tokens/:id/cleartext*/
    TokensResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/tokens',
            headers: params.headers,
            method: 'GET',
            query: {
                id: params.id,
                limit: params.limit,
                mine: params.mine,
                offset: params.offset,
                organization: params.organization,
                partner: params.partner,
                sort: params.sort,
            },
        });
    };
    /*Preferred method to validate a token, obtaining specific information if the token is valid (or a 404 if the token does not exist). We use an HTTP POST with a form body to ensure that the token itself is not logged in the request logs.*/
    TokensResource.prototype.postAuthentications = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/tokens/authentications',
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Get metadata for the token with this ID*/
    TokensResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/tokens/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    TokensResource.prototype.deleteById = function (params) {
        return this.client.request({
            endpoint: "/tokens/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'DELETE',
        });
    };
    /*Retrieves the token with the actual string token in cleartext*/
    TokensResource.prototype.getCleartextById = function (params) {
        return this.client.request({
            endpoint: "/tokens/" + encodeURIComponent(params.id) + "/cleartext",
            headers: params.headers,
            method: 'GET',
        });
    };
    return TokensResource;
}($Resource));
export { TokensResource };
var TokenValidationsResource = /** @class */ (function (_super) {
    __extends(TokenValidationsResource, _super);
    function TokenValidationsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TokenValidationsResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/token-validations',
            headers: params.headers,
            method: 'POST',
        });
    };
    return TokenValidationsResource;
}($Resource));
export { TokenValidationsResource };
var UploadsResource = /** @class */ (function (_super) {
    __extends(UploadsResource, _super);
    function UploadsResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UploadsResource.prototype.postByName = function (params) {
        return this.client.request({
            endpoint: "/" + encodeURIComponent(params.organization) + "/uploads/" + encodeURIComponent(params.name),
            headers: params.headers,
            method: 'POST',
        });
    };
    return UploadsResource;
}($Resource));
export { UploadsResource };
var UsersResource = /** @class */ (function (_super) {
    __extends(UsersResource, _super);
    function UsersResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*Search users. Must specify an id or email.*/
    UsersResource.prototype.get = function (params) {
        return this.client.request({
            endpoint: '/users',
            headers: params.headers,
            method: 'GET',
            query: {
                email: params.email,
                id: params.id,
                limit: params.limit,
                offset: params.offset,
                sort: params.sort,
                status: params.status,
            },
        });
    };
    /*Create a new user. Note that new users will be created with a status of pending and will not be able to authenticate until approved by a member of the Flow team.*/
    UsersResource.prototype.post = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/users',
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Authenticates a user by email / password. Note only users that have a status of active will be authorized.*/
    UsersResource.prototype.postAuthenticate = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: '/users/authenticate',
            headers: params.headers,
            method: 'POST',
        });
    };
    /*Returns information about a specific user.*/
    UsersResource.prototype.getById = function (params) {
        return this.client.request({
            endpoint: "/users/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'GET',
        });
    };
    /*Update a user.*/
    UsersResource.prototype.putById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/users/" + encodeURIComponent(params.id),
            headers: params.headers,
            method: 'PUT',
        });
    };
    /*Update the password for a user.*/
    UsersResource.prototype.patchPasswordsById = function (params) {
        return this.client.request({
            body: params.body,
            endpoint: "/users/" + encodeURIComponent(params.id) + "/passwords",
            headers: params.headers,
            method: 'PATCH',
        });
    };
    /*Deletes a password for the given user.*/
    UsersResource.prototype.deletePasswordsById = function (params) {
        return this.client.request({
            endpoint: "/users/" + encodeURIComponent(params.id) + "/passwords",
            headers: params.headers,
            method: 'DELETE',
        });
    };
    return UsersResource;
}($Resource));
export { UsersResource };
export function createClient(options) {
    return {
        addressConfigurations: new AddressConfigurationsResource(options),
        allocations: new AllocationsResource(options),
        attributes: new AttributesResource(options),
        catalogs: new CatalogsResource(options),
        checkoutAttributes: new CheckoutAttributesResource(options),
        checkoutItemContents: new CheckoutItemContentsResource(options),
        creditPayments: new CreditPaymentsResource(options),
        discountRuleSettings: new DiscountRuleSettingsResource(options),
        experiences: new ExperiencesResource(options),
        experienceCheckoutSettings: new ExperienceCheckoutSettingsResource(options),
        experienceDefaults: new ExperienceDefaultsResource(options),
        experienceLogisticsSettings: new ExperienceLogisticsSettingsResource(options),
        experiencePriceConversions: new ExperiencePriceConversionsResource(options),
        experiencePriceFacetConversions: new ExperiencePriceFacetConversionsResource(options),
        items: new ItemsResource(options),
        itemFormOverlays: new ItemFormOverlaysResource(options),
        orders: new OrdersResource(options),
        orderBuilders: new OrderBuildersResource(options),
        orderEstimates: new OrderEstimatesResource(options),
        orderIdentifiers: new OrderIdentifiersResource(options),
        orderNumberGenerators: new OrderNumberGeneratorsResource(options),
        orderPromotions: new OrderPromotionsResource(options),
        orderSummaries: new OrderSummariesResource(options),
        organizations: new OrganizationsResource(options),
        paymentMethodRules: new PaymentMethodRulesResource(options),
        priceBooks: new PriceBooksResource(options),
        priceBookItems: new PriceBookItemsResource(options),
        subcatalogs: new SubcatalogsResource(options),
        subcatalogItems: new SubcatalogItemsResource(options),
        rates: new RatesResource(options),
        harmonizedLandedCosts: new HarmonizedLandedCostsResource(options),
        hs10: new Hs10Resource(options),
        taxRegistrations: new TaxRegistrationsResource(options),
        authorizations: new AuthorizationsResource(options),
        captures: new CapturesResource(options),
        cards: new CardsResource(options),
        cardPaymentSources: new CardPaymentSourcesResource(options),
        gatewayAuthenticationData: new GatewayAuthenticationDataResource(options),
        payments: new PaymentsResource(options),
        publicKeys: new PublicKeysResource(options),
        refunds: new RefundsResource(options),
        reversals: new ReversalsResource(options),
        virtualCards: new VirtualCardsResource(options),
        virtualCardCaptures: new VirtualCardCapturesResource(options),
        virtualCardRefunds: new VirtualCardRefundsResource(options),
        centers: new CentersResource(options),
        deliveryWindows: new DeliveryWindowsResource(options),
        dimensionEstimates: new DimensionEstimatesResource(options),
        inventoryRules: new InventoryRulesResource(options),
        inventorySnapshots: new InventorySnapshotsResource(options),
        inventoryUpdates: new InventoryUpdatesResource(options),
        manifests: new ManifestsResource(options),
        quotes: new QuotesResource(options),
        ratecards: new RatecardsResource(options),
        ratecardEstimates: new RatecardEstimatesResource(options),
        ratecardLanes: new RatecardLanesResource(options),
        ratecardRates: new RatecardRatesResource(options),
        returns: new ReturnsResource(options),
        shippingConfigurations: new ShippingConfigurationsResource(options),
        shippingConfigurationCopies: new ShippingConfigurationCopiesResource(options),
        shippingLabels: new ShippingLabelsResource(options),
        shippingNotifications: new ShippingNotificationsResource(options),
        surchargeSettings: new SurchargeSettingsResource(options),
        tiers: new TiersResource(options),
        trackings: new TrackingsResource(options),
        trackingEvents: new TrackingEventsResource(options),
        trackingLabels: new TrackingLabelsResource(options),
        webhooks: new WebhooksResource(options),
        webhookDeliveries: new WebhookDeliveriesResource(options),
        webhookSettings: new WebhookSettingsResource(options),
        addresses: new AddressesResource(options),
        countryDefaults: new CountryDefaultsResource(options),
        timezones: new TimezonesResource(options),
        carriers: new CarriersResource(options),
        carrierServices: new CarrierServicesResource(options),
        countries: new CountriesResource(options),
        currencies: new CurrenciesResource(options),
        languages: new LanguagesResource(options),
        locales: new LocalesResource(options),
        paymentMethods: new PaymentMethodsResource(options),
        provinces: new ProvincesResource(options),
        regions: new RegionsResource(options),
        abandonedOrderSettings: new AbandonedOrderSettingsResource(options),
        b2BCreditMemos: new B2BCreditMemosResource(options),
        b2BInvoices: new B2BInvoicesResource(options),
        catalogPriceBookItemDocuments: new CatalogPriceBookItemDocumentsResource(options),
        checkoutTokens: new CheckoutTokensResource(options),
        consumerInvoices: new ConsumerInvoicesResource(options),
        consumerInvoiceDocuments: new ConsumerInvoiceDocumentsResource(options),
        countryPickers: new CountryPickersResource(options),
        creditMemos: new CreditMemosResource(options),
        customers: new CustomersResource(options),
        customerAddressBook: new CustomerAddressBookResource(options),
        customerAddressBookContacts: new CustomerAddressBookContactsResource(options),
        customerBundles: new CustomerBundlesResource(options),
        customerPurgeSettings: new CustomerPurgeSettingsResource(options),
        customerTokens: new CustomerTokensResource(options),
        documents: new DocumentsResource(options),
        ecommercePlatforms: new EcommercePlatformsResource(options),
        emailVerifications: new EmailVerificationsResource(options),
        exclusionRules: new ExclusionRulesResource(options),
        exports: new ExportsResource(options),
        flowRoles: new FlowRolesResource(options),
        fraudEmailRules: new FraudEmailRulesResource(options),
        ftpFiles: new FtpFilesResource(options),
        ftpFolders: new FtpFoldersResource(options),
        ftpOrganizationSettings: new FtpOrganizationSettingsResource(options),
        fulfillments: new FulfillmentsResource(options),
        healthchecks: new HealthchecksResource(options),
        imports: new ImportsResource(options),
        importTemplates: new ImportTemplatesResource(options),
        invitations: new InvitationsResource(options),
        priceRules: new PriceRulesResource(options),
        itemQuerySuggestions: new ItemQuerySuggestionsResource(options),
        links: new LinksResource(options),
        memberships: new MembershipsResource(options),
        merchantGiftCardBalances: new MerchantGiftCardBalancesResource(options),
        merchantGiftCardRedemptions: new MerchantGiftCardRedemptionsResource(options),
        merchantGiftCardReversals: new MerchantGiftCardReversalsResource(options),
        organizationAuthorizations: new OrganizationAuthorizationsResource(options),
        organizationDefaultConfigurations: new OrganizationDefaultConfigurationsResource(options),
        organizationTokens: new OrganizationTokensResource(options),
        partnerTokens: new PartnerTokensResource(options),
        passwordResetForms: new PasswordResetFormsResource(options),
        permissionChecks: new PermissionChecksResource(options),
        priceBookItemExportOptions: new PriceBookItemExportOptionsResource(options),
        scheduledExports: new ScheduledExportsResource(options),
        sessions: new SessionsResource(options),
        sessionAuthorizations: new SessionAuthorizationsResource(options),
        shopifyCarts: new ShopifyCartsResource(options),
        shopifyCartConversions: new ShopifyCartConversionsResource(options),
        shopifyLocalizationSettings: new ShopifyLocalizationSettingsResource(options),
        shopifyLocationFlowCenterMappings: new ShopifyLocationFlowCenterMappingsResource(options),
        shopifyPrivateApps: new ShopifyPrivateAppsResource(options),
        shopifySyncStatuses: new ShopifySyncStatusesResource(options),
        suggestions: new SuggestionsResource(options),
        syncPendingRecords: new SyncPendingRecordsResource(options),
        syncRecords: new SyncRecordsResource(options),
        syncRecordFailures: new SyncRecordFailuresResource(options),
        syncStreams: new SyncStreamsResource(options),
        taxSettings: new TaxSettingsResource(options),
        tokens: new TokensResource(options),
        tokenValidations: new TokenValidationsResource(options),
        uploads: new UploadsResource(options),
        users: new UsersResource(options),
    };
}



//////////////////
// WEBPACK FOOTER
// ./~/@flowio/api-sdk/dist/esm/api.js
// module id = 460
// module chunks = 0 1